// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import "./components/reboot";
@import "./components/grid";
@import "./components/type";
@import "./components/buttons";
@import "./components/forms";
@import "./components/input-group";
@import "./components/text";
@import "./components/custom-forms"; */
* {
  box-sizing: border-box;
}

.material-icons {
  box-sizing: content-box;
  box-sizing: initial;
}

html {
  font-size: 14px;
}

body {
  margin: 0;
  padding: 0;
  font-family: Poppins, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.ff-1 {
  font-family: "Poppins", sans-serif !important;
}

.ff-2 {
  font-family: "PT Sans", sans-serif !important;
}

.ff-3 {
  font-family: "Raleway", sans-serif !important;
}

.ff-4 {
  font-family: "Poppins", sans-serif !important;
}

.ff-5 {
  font-family: "Nunito", sans-serif !important;
}

.hover {
  cursor: pointer;
}

.no-margin {
  margin: 0;
}

.mb-5 {
  margin-bottom: 5px;
}

.leaflet-container {
  font-family: inherit;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

a {
  text-decoration: none;
}
a:hover {
  text-decoration: none;
}

.list-unstyled {
  list-style: none;
}

.montoring-addres {
  font-style: italic;
  font-size: 11px;
  font-weight: 400;
  padding: 0 5px;
  color: #27272E;
  max-Width: 90%;
  height: 2.6em;
  line-height: 1.3em;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  margin: 11px 0px;
  -webkit-box-orientt: vertical;
}

.badge {
  display: inline-block;
  width: 1.2em;
  height: 1.2em;
  line-height: 1.2em;
  color: #fff;
  font-size: 14px;
  background: #666;
  text-align: center;
  border-radius: 50%;
}

.text-theme {
  color: #00c179;
}

.clearfix:before, .clearfix:after {
  display: table;
  content: " ";
  clear: both;
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

.text-normal {
  font-size: 14px;
}

.v-hidden {
  visibility: hidden;
}

.form-check-label label,
.form-check-label {
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  margin: 0;
}

.checkbox {
  -webkit-user-select: none;
  user-select: none;
  margin: 0;
}
.checkbox input {
  display: none;
}
.form-check-inline .checkbox input + span {
  margin-right: 5px;
}
.checkbox input + span {
  vertical-align: top;
  font-size: 14px;
  display: inline-block;
}
.checkbox input + span span {
  height: auto;
  line-height: inherit;
}
.checkbox input + span .on-active {
  display: none;
}
.checkbox input:checked + span .on-active {
  display: inline-block;
}
.checkbox input:checked + span .on-inactive {
  display: none;
}

.has-menu {
  position: relative;
}
.has-menu .has-menu > a:after {
  content: "keyboard_arrow_right";
  display: block;
  position: absolute;
  right: 0;
  top: 0;
  font-family: "Material Icons";
  font-size: 20px;
}

.horizontal-menu ul {
  white-space: nowrap;
}

.horizontal-menu li {
  display: inline-block;
  height: auto;
}

.sub-menu {
  position: absolute;
  top: 100%;
  background: #fff;
  border-top: 3px solid transparent;
  margin: 0;
  margin-top: -3px;
  padding: 0;
  list-style: none;
  min-width: 180px;
  left: 0;
  display: none;
  text-align: left;
  line-height: 1.4;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
  z-index: 9;
}
.sub-menu li a {
  font-size: 12px;
  color: #333;
  text-decoration: none;
  display: block;
}
.sub-menu li a:hover .rel-icons {
  color: inherit;
}
.sub-menu label span,
.sub-menu a span {
  vertical-align: middle;
  display: inline-block;
}
.sub-menu.right-menu {
  left: auto;
  right: 0;
}
.sub-menu.level-right {
  top: 0;
  left: 100%;
}
.sub-menu.level-left {
  top: 0;
  right: 100%;
  left: auto;
}
.sub-menu.left-top {
  bottom: 100%;
  top: auto;
}
.sub-menu.right-top {
  bottom: 100%;
  top: auto;
  right: 0;
  left: auto;
}
.sub-menu a {
  padding: 6px 9px;
}
.sub-menu label {
  display: block;
  margin: 0;
}
.sub-menu label input {
  vertical-align: middle;
  margin-right: 5px;
}
.sub-menu .rel-icons {
  margin-right: 5px;
  color: #aaa;
}

:hover > .sub-menu {
  display: block;
}

.divider {
  border-top: 1px solid rgb(178.5, 178.5, 178.5);
}

.sub-menu label:hover,
.sub-menu .active a,
.sub-menu a:hover {
  background: #fff;
  color: #00c179;
}

.center-menu {
  left: 50%;
  width: 340px;
  margin-left: -170px;
}

.marker {
  transition: transform 0.4s linear;
}

.leaflet-tooltip.has-animation {
  transition: transform 0.4s linear;
}
.leaflet-tooltip.has-animation img {
  transition: all 0.4s linear;
}

.color-inherit {
  color: inherit !important;
}

.selector-count {
  padding: 0 0 6px;
  font-size: 10px;
  display: flex;
  justify-content: space-between;
}

.geofences-columns-wise .ScrollbarsCustom-Wrapper {
  margin: 0 -15px;
}
.geofences-columns-wise .geoList {
  display: flex;
  flex-direction: column;
  /* .list-row-1 {
     width: 49%;
  } */
}

/* .custom-tabs .Mui-disabled {
  display: none;
}
 */
.seconds_1 {
  transition: transform 1s linear;
}
.seconds_1 img {
  transition: all 1s linear;
}

.seconds_2 {
  transition: transform 2s linear;
}
.seconds_2 img {
  transition: all 2s linear;
}

.seconds_3 {
  transition: transform 3s linear;
}
.seconds_3 img {
  transition: all 3s linear;
}

.seconds_4 {
  transition: transform 4s linear;
}
.seconds_4 img {
  transition: all 4s linear;
}

.seconds_5 {
  transition: transform 5s linear;
}
.seconds_5 img {
  transition: all 5s linear;
}

.seconds_6 {
  transition: transform 6s linear;
}
.seconds_6 img {
  transition: all 6s linear;
}

.seconds_7 {
  transition: transform 7s linear;
}
.seconds_7 img {
  transition: all 7s linear;
}

.seconds_8 {
  transition: transform 8s linear;
}
.seconds_8 img {
  transition: all 8s linear;
}

.seconds_9 {
  transition: transform 9s linear;
}
.seconds_9 img {
  transition: all 9s linear;
}

.seconds_10 {
  transition: transform 10s linear;
}
.seconds_10 img {
  transition: all 10s linear;
}

.seconds_11 {
  transition: transform 11s linear;
}
.seconds_11 img {
  transition: all 11s linear;
}

.seconds_12 {
  transition: transform 12s linear;
}
.seconds_12 img {
  transition: all 12s linear;
}

.seconds_13 {
  transition: transform 13s linear;
}
.seconds_13 img {
  transition: all 13s linear;
}

.seconds_14 {
  transition: transform 14s linear;
}
.seconds_14 img {
  transition: all 14s linear;
}

.seconds_15 {
  transition: transform 15s linear;
}
.seconds_15 img {
  transition: all 15s linear;
}

.seconds_16 {
  transition: transform 16s linear;
}
.seconds_16 img {
  transition: all 16s linear;
}

.seconds_17 {
  transition: transform 17s linear;
}
.seconds_17 img {
  transition: all 17s linear;
}

.seconds_18 {
  transition: transform 18s linear;
}
.seconds_18 img {
  transition: all 18s linear;
}

.seconds_19 {
  transition: transform 19s linear;
}
.seconds_19 img {
  transition: all 19s linear;
}

.seconds_20 {
  transition: transform 20s linear;
}
.seconds_20 img {
  transition: all 20s linear;
}

.seconds_21 {
  transition: transform 21s linear;
}
.seconds_21 img {
  transition: all 21s linear;
}

.seconds_22 {
  transition: transform 22s linear;
}
.seconds_22 img {
  transition: all 22s linear;
}

.seconds_23 {
  transition: transform 23s linear;
}
.seconds_23 img {
  transition: all 23s linear;
}

.seconds_24 {
  transition: transform 24s linear;
}
.seconds_24 img {
  transition: all 24s linear;
}

.seconds_25 {
  transition: transform 25s linear;
}
.seconds_25 img {
  transition: all 25s linear;
}

.seconds_26 {
  transition: transform 26s linear;
}
.seconds_26 img {
  transition: all 26s linear;
}

.seconds_27 {
  transition: transform 27s linear;
}
.seconds_27 img {
  transition: all 27s linear;
}

.seconds_28 {
  transition: transform 28s linear;
}
.seconds_28 img {
  transition: all 28s linear;
}

.seconds_29 {
  transition: transform 29s linear;
}
.seconds_29 img {
  transition: all 29s linear;
}

.seconds_30 {
  transition: transform 30s linear;
}
.seconds_30 img {
  transition: all 30s linear;
}

.seconds_31 {
  transition: transform 31s linear;
}
.seconds_31 img {
  transition: all 31s linear;
}

.seconds_32 {
  transition: transform 32s linear;
}
.seconds_32 img {
  transition: all 32s linear;
}

.seconds_33 {
  transition: transform 33s linear;
}
.seconds_33 img {
  transition: all 33s linear;
}

.seconds_34 {
  transition: transform 34s linear;
}
.seconds_34 img {
  transition: all 34s linear;
}

.seconds_35 {
  transition: transform 35s linear;
}
.seconds_35 img {
  transition: all 35s linear;
}

.seconds_36 {
  transition: transform 36s linear;
}
.seconds_36 img {
  transition: all 36s linear;
}

.seconds_37 {
  transition: transform 37s linear;
}
.seconds_37 img {
  transition: all 37s linear;
}

.seconds_38 {
  transition: transform 38s linear;
}
.seconds_38 img {
  transition: all 38s linear;
}

.seconds_39 {
  transition: transform 39s linear;
}
.seconds_39 img {
  transition: all 39s linear;
}

.seconds_40 {
  transition: transform 40s linear;
}
.seconds_40 img {
  transition: all 40s linear;
}

.seconds_41 {
  transition: transform 41s linear;
}
.seconds_41 img {
  transition: all 41s linear;
}

.seconds_42 {
  transition: transform 42s linear;
}
.seconds_42 img {
  transition: all 42s linear;
}

.seconds_43 {
  transition: transform 43s linear;
}
.seconds_43 img {
  transition: all 43s linear;
}

.seconds_44 {
  transition: transform 44s linear;
}
.seconds_44 img {
  transition: all 44s linear;
}

.seconds_45 {
  transition: transform 45s linear;
}
.seconds_45 img {
  transition: all 45s linear;
}

.seconds_46 {
  transition: transform 46s linear;
}
.seconds_46 img {
  transition: all 46s linear;
}

.seconds_47 {
  transition: transform 47s linear;
}
.seconds_47 img {
  transition: all 47s linear;
}

.seconds_48 {
  transition: transform 48s linear;
}
.seconds_48 img {
  transition: all 48s linear;
}

.seconds_49 {
  transition: transform 49s linear;
}
.seconds_49 img {
  transition: all 49s linear;
}

.seconds_50 {
  transition: transform 50s linear;
}
.seconds_50 img {
  transition: all 50s linear;
}

.seconds_51 {
  transition: transform 51s linear;
}
.seconds_51 img {
  transition: all 51s linear;
}

.seconds_52 {
  transition: transform 52s linear;
}
.seconds_52 img {
  transition: all 52s linear;
}

.seconds_53 {
  transition: transform 53s linear;
}
.seconds_53 img {
  transition: all 53s linear;
}

.seconds_54 {
  transition: transform 54s linear;
}
.seconds_54 img {
  transition: all 54s linear;
}

.seconds_55 {
  transition: transform 55s linear;
}
.seconds_55 img {
  transition: all 55s linear;
}

.seconds_56 {
  transition: transform 56s linear;
}
.seconds_56 img {
  transition: all 56s linear;
}

.seconds_57 {
  transition: transform 57s linear;
}
.seconds_57 img {
  transition: all 57s linear;
}

.seconds_58 {
  transition: transform 58s linear;
}
.seconds_58 img {
  transition: all 58s linear;
}

.seconds_59 {
  transition: transform 59s linear;
}
.seconds_59 img {
  transition: all 59s linear;
}

.seconds_60 {
  transition: transform 60s linear;
}
.seconds_60 img {
  transition: all 60s linear;
}

.scroll-width-0 {
  /* .left-nav {
    .nav {
      margin-right: -\$i * 1px;
      box-sizing: content-box;
      overflow: scroll;
      position: relative;
    }
  } */
}
.scroll-width-0 .geofence-modal-form-inner {
  margin-right: 0px;
}
.scroll-width-0 .notification-scroller {
  margin-right: 0px;
}

.scroll-width-1 {
  /* .left-nav {
    .nav {
      margin-right: -\$i * 1px;
      box-sizing: content-box;
      overflow: scroll;
      position: relative;
    }
  } */
}
.scroll-width-1 .geofence-modal-form-inner {
  margin-right: -1px;
}
.scroll-width-1 .notification-scroller {
  margin-right: -1px;
}

.scroll-width-2 {
  /* .left-nav {
    .nav {
      margin-right: -\$i * 1px;
      box-sizing: content-box;
      overflow: scroll;
      position: relative;
    }
  } */
}
.scroll-width-2 .geofence-modal-form-inner {
  margin-right: -2px;
}
.scroll-width-2 .notification-scroller {
  margin-right: -2px;
}

.scroll-width-3 {
  /* .left-nav {
    .nav {
      margin-right: -\$i * 1px;
      box-sizing: content-box;
      overflow: scroll;
      position: relative;
    }
  } */
}
.scroll-width-3 .geofence-modal-form-inner {
  margin-right: -3px;
}
.scroll-width-3 .notification-scroller {
  margin-right: -3px;
}

.scroll-width-4 {
  /* .left-nav {
    .nav {
      margin-right: -\$i * 1px;
      box-sizing: content-box;
      overflow: scroll;
      position: relative;
    }
  } */
}
.scroll-width-4 .geofence-modal-form-inner {
  margin-right: -4px;
}
.scroll-width-4 .notification-scroller {
  margin-right: -4px;
}

.scroll-width-5 {
  /* .left-nav {
    .nav {
      margin-right: -\$i * 1px;
      box-sizing: content-box;
      overflow: scroll;
      position: relative;
    }
  } */
}
.scroll-width-5 .geofence-modal-form-inner {
  margin-right: -5px;
}
.scroll-width-5 .notification-scroller {
  margin-right: -5px;
}

.scroll-width-6 {
  /* .left-nav {
    .nav {
      margin-right: -\$i * 1px;
      box-sizing: content-box;
      overflow: scroll;
      position: relative;
    }
  } */
}
.scroll-width-6 .geofence-modal-form-inner {
  margin-right: -6px;
}
.scroll-width-6 .notification-scroller {
  margin-right: -6px;
}

.scroll-width-7 {
  /* .left-nav {
    .nav {
      margin-right: -\$i * 1px;
      box-sizing: content-box;
      overflow: scroll;
      position: relative;
    }
  } */
}
.scroll-width-7 .geofence-modal-form-inner {
  margin-right: -7px;
}
.scroll-width-7 .notification-scroller {
  margin-right: -7px;
}

.scroll-width-8 {
  /* .left-nav {
    .nav {
      margin-right: -\$i * 1px;
      box-sizing: content-box;
      overflow: scroll;
      position: relative;
    }
  } */
}
.scroll-width-8 .geofence-modal-form-inner {
  margin-right: -8px;
}
.scroll-width-8 .notification-scroller {
  margin-right: -8px;
}

.scroll-width-9 {
  /* .left-nav {
    .nav {
      margin-right: -\$i * 1px;
      box-sizing: content-box;
      overflow: scroll;
      position: relative;
    }
  } */
}
.scroll-width-9 .geofence-modal-form-inner {
  margin-right: -9px;
}
.scroll-width-9 .notification-scroller {
  margin-right: -9px;
}

.scroll-width-10 {
  /* .left-nav {
    .nav {
      margin-right: -\$i * 1px;
      box-sizing: content-box;
      overflow: scroll;
      position: relative;
    }
  } */
}
.scroll-width-10 .geofence-modal-form-inner {
  margin-right: -10px;
}
.scroll-width-10 .notification-scroller {
  margin-right: -10px;
}

.scroll-width-11 {
  /* .left-nav {
    .nav {
      margin-right: -\$i * 1px;
      box-sizing: content-box;
      overflow: scroll;
      position: relative;
    }
  } */
}
.scroll-width-11 .geofence-modal-form-inner {
  margin-right: -11px;
}
.scroll-width-11 .notification-scroller {
  margin-right: -11px;
}

.scroll-width-12 {
  /* .left-nav {
    .nav {
      margin-right: -\$i * 1px;
      box-sizing: content-box;
      overflow: scroll;
      position: relative;
    }
  } */
}
.scroll-width-12 .geofence-modal-form-inner {
  margin-right: -12px;
}
.scroll-width-12 .notification-scroller {
  margin-right: -12px;
}

.scroll-width-13 {
  /* .left-nav {
    .nav {
      margin-right: -\$i * 1px;
      box-sizing: content-box;
      overflow: scroll;
      position: relative;
    }
  } */
}
.scroll-width-13 .geofence-modal-form-inner {
  margin-right: -13px;
}
.scroll-width-13 .notification-scroller {
  margin-right: -13px;
}

.scroll-width-14 {
  /* .left-nav {
    .nav {
      margin-right: -\$i * 1px;
      box-sizing: content-box;
      overflow: scroll;
      position: relative;
    }
  } */
}
.scroll-width-14 .geofence-modal-form-inner {
  margin-right: -14px;
}
.scroll-width-14 .notification-scroller {
  margin-right: -14px;
}

.scroll-width-15 {
  /* .left-nav {
    .nav {
      margin-right: -\$i * 1px;
      box-sizing: content-box;
      overflow: scroll;
      position: relative;
    }
  } */
}
.scroll-width-15 .geofence-modal-form-inner {
  margin-right: -15px;
}
.scroll-width-15 .notification-scroller {
  margin-right: -15px;
}

.scroll-width-16 {
  /* .left-nav {
    .nav {
      margin-right: -\$i * 1px;
      box-sizing: content-box;
      overflow: scroll;
      position: relative;
    }
  } */
}
.scroll-width-16 .geofence-modal-form-inner {
  margin-right: -16px;
}
.scroll-width-16 .notification-scroller {
  margin-right: -16px;
}

.scroll-width-17 {
  /* .left-nav {
    .nav {
      margin-right: -\$i * 1px;
      box-sizing: content-box;
      overflow: scroll;
      position: relative;
    }
  } */
}
.scroll-width-17 .geofence-modal-form-inner {
  margin-right: -17px;
}
.scroll-width-17 .notification-scroller {
  margin-right: -17px;
}

.scroll-width-18 {
  /* .left-nav {
    .nav {
      margin-right: -\$i * 1px;
      box-sizing: content-box;
      overflow: scroll;
      position: relative;
    }
  } */
}
.scroll-width-18 .geofence-modal-form-inner {
  margin-right: -18px;
}
.scroll-width-18 .notification-scroller {
  margin-right: -18px;
}

.scroll-width-19 {
  /* .left-nav {
    .nav {
      margin-right: -\$i * 1px;
      box-sizing: content-box;
      overflow: scroll;
      position: relative;
    }
  } */
}
.scroll-width-19 .geofence-modal-form-inner {
  margin-right: -19px;
}
.scroll-width-19 .notification-scroller {
  margin-right: -19px;
}

.scroll-width-20 {
  /* .left-nav {
    .nav {
      margin-right: -\$i * 1px;
      box-sizing: content-box;
      overflow: scroll;
      position: relative;
    }
  } */
}
.scroll-width-20 .geofence-modal-form-inner {
  margin-right: -20px;
}
.scroll-width-20 .notification-scroller {
  margin-right: -20px;
}

.scroll-width-21 {
  /* .left-nav {
    .nav {
      margin-right: -\$i * 1px;
      box-sizing: content-box;
      overflow: scroll;
      position: relative;
    }
  } */
}
.scroll-width-21 .geofence-modal-form-inner {
  margin-right: -21px;
}
.scroll-width-21 .notification-scroller {
  margin-right: -21px;
}

.scroll-width-22 {
  /* .left-nav {
    .nav {
      margin-right: -\$i * 1px;
      box-sizing: content-box;
      overflow: scroll;
      position: relative;
    }
  } */
}
.scroll-width-22 .geofence-modal-form-inner {
  margin-right: -22px;
}
.scroll-width-22 .notification-scroller {
  margin-right: -22px;
}

.scroll-width-23 {
  /* .left-nav {
    .nav {
      margin-right: -\$i * 1px;
      box-sizing: content-box;
      overflow: scroll;
      position: relative;
    }
  } */
}
.scroll-width-23 .geofence-modal-form-inner {
  margin-right: -23px;
}
.scroll-width-23 .notification-scroller {
  margin-right: -23px;
}

.scroll-width-24 {
  /* .left-nav {
    .nav {
      margin-right: -\$i * 1px;
      box-sizing: content-box;
      overflow: scroll;
      position: relative;
    }
  } */
}
.scroll-width-24 .geofence-modal-form-inner {
  margin-right: -24px;
}
.scroll-width-24 .notification-scroller {
  margin-right: -24px;
}

.scroll-width-25 {
  /* .left-nav {
    .nav {
      margin-right: -\$i * 1px;
      box-sizing: content-box;
      overflow: scroll;
      position: relative;
    }
  } */
}
.scroll-width-25 .geofence-modal-form-inner {
  margin-right: -25px;
}
.scroll-width-25 .notification-scroller {
  margin-right: -25px;
}

.scroll-width-26 {
  /* .left-nav {
    .nav {
      margin-right: -\$i * 1px;
      box-sizing: content-box;
      overflow: scroll;
      position: relative;
    }
  } */
}
.scroll-width-26 .geofence-modal-form-inner {
  margin-right: -26px;
}
.scroll-width-26 .notification-scroller {
  margin-right: -26px;
}

.scroll-width-27 {
  /* .left-nav {
    .nav {
      margin-right: -\$i * 1px;
      box-sizing: content-box;
      overflow: scroll;
      position: relative;
    }
  } */
}
.scroll-width-27 .geofence-modal-form-inner {
  margin-right: -27px;
}
.scroll-width-27 .notification-scroller {
  margin-right: -27px;
}

.scroll-width-28 {
  /* .left-nav {
    .nav {
      margin-right: -\$i * 1px;
      box-sizing: content-box;
      overflow: scroll;
      position: relative;
    }
  } */
}
.scroll-width-28 .geofence-modal-form-inner {
  margin-right: -28px;
}
.scroll-width-28 .notification-scroller {
  margin-right: -28px;
}

.scroll-width-29 {
  /* .left-nav {
    .nav {
      margin-right: -\$i * 1px;
      box-sizing: content-box;
      overflow: scroll;
      position: relative;
    }
  } */
}
.scroll-width-29 .geofence-modal-form-inner {
  margin-right: -29px;
}
.scroll-width-29 .notification-scroller {
  margin-right: -29px;
}

.scroll-width-30 {
  /* .left-nav {
    .nav {
      margin-right: -\$i * 1px;
      box-sizing: content-box;
      overflow: scroll;
      position: relative;
    }
  } */
}
.scroll-width-30 .geofence-modal-form-inner {
  margin-right: -30px;
}
.scroll-width-30 .notification-scroller {
  margin-right: -30px;
}

.ref-marker {
  background: none;
}

.pos-name {
  position: absolute;
  width: 320px;
  left: 50%;
  margin-left: -160px;
  bottom: 100%;
  box-sizing: border-box;
  /* span {
    font-size: 12px;
    background: #fff;
    border-radius: 3px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
    padding: 6px;
    display: inline-block;
  } */
  display: none;
}

.marker:hover .pos-name {
  display: block;
}

.custom-marker.leaflet-marker-icon {
  background: none;
  border: 0;
}
.custom-marker.leaflet-marker-icon img {
  max-width: 100% !important;
  height: auto;
}

.hide-delete-btn .leaflet-draw-actions-bottom {
  display: none !important;
}

.form-group {
  margin-bottom: 25px;
}

.hilight {
  border: 1px solid #B2B5C4;
  color: #00c179;
  background: #fff;
  padding: 6px;
  display: inline-block;
  border-radius: 4px;
  margin: 6px 0;
}

.inline-buttons .theme-button,
.inline-buttons button {
  margin-right: 8px;
}

.ml-auto {
  margin-left: auto;
}

.page-title {
  font-size: 14px;
  font-weight: 700;
  padding: 0 0 4px;
  margin: 0 0 10px;
  font-weight: normal;
}

.page-title-notification {
  margin: 0 0 10px;
  padding: 0 0 4px;
  font-weight: bold;
  font-size: 14px;
}

.page-subtitle-notification {
  font-weight: normal;
  margin: 0;
  padding: 0 0 4px;
  font-size: 14px;
}

.report-list-wrapper .ScrollbarsCustom-Wrapper {
  margin: 0 -15px;
}

.selector-check {
  margin-right: 10px;
}

.report-sidebar-switch {
  margin: 0 0px;
  display: flex;
}
.report-sidebar-switch:after {
  content: "";
  display: block;
  height: 1px;
  background: #fff;
  margin: 10px auto;
}
.report-sidebar-switch .theme-button {
  min-width: 70px !important;
  margin: 0 4px 0 0;
}
.report-sidebar-switch ~ .report-sidebar-switch:after {
  margin-bottom: 0;
}

.clearAllNotifcations {
  position: absolute;
  z-index: 999;
  background: #f7f7f7;
  border: 0;
  width: 100%;
  padding: 10px 30px;
  font-size: 16px;
  right: 10px;
  max-width: 300px;
  top: 155px;
  cursor: pointer;
  box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.2);
}

.notifications-tr {
  margin-top: 143px;
}

.shown-clearall-btn .notifications-tr {
  margin-top: 195px;
}

.notification-visible {
  height: auto !important;
}

.notification-dismiss {
  font-size: 22px !important;
  line-height: 22px !important;
  width: 22px !important;
  height: 22px !important;
  background: none !important;
  top: 6.5px !important;
  right: 7px !important;
}

.progress-green,
.notification-success {
  background: #43a047 !important;
  border-color: #43a047 !important;
  color: #fff !important;
}

.progress-yellow,
.notification-warning {
  background: #ffa000 !important;
  border-color: #ffa000 !important;
  color: #fff !important;
}

.progress-red,
.notification-error {
  background: #d32f2f !important;
  border-color: #d32f2f !important;
  color: #fff !important;
}

.notification-info {
  background: #1976d2 !important;
  border-color: #1976d2 !important;
  color: #fff !important;
}

.notification-title {
  color: #fff !important;
}

.notification-visible {
  color: #fff !important;
  padding: 8px 16px !important;
  font-size: 14px !important;
  letter-spacing: 0.01071em;
  line-height: 1.43;
  border-radius: 4px !important;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12) !important;
}
.notification-visible:hover .notification-dismiss {
  display: block;
}

.notification-inner-box {
  border-radius: 4px;
  margin: -10px -16px -8px;
  padding: 10px 16px 8px;
}

.tab-title {
  margin: 0 0 10px;
  padding: 6px 12px;
  border-radius: 7px;
  font-weight: 600;
}

.text-danger {
  color: #d32f2f;
}

@media (min-width: 600px) {
  .MuiTab-root {
    min-width: 80px !important;
  }
  .MuiTabs-root {
    min-height: 32px !important;
    margin-bottom: -5px;
    position: relative;
    z-index: 1;
  }
}
.text-center {
  text-align: center;
}

.text-left {
  text-align: left;
}

.text-right {
  text-align: right;
}

.text-default {
  color: inherit;
}

.table-fields-list .smooth-dnd-draggable-wrapper:nth-child(odd) {
  background: #fafafa;
}
.table-fields-list .smooth-dnd-draggable-wrapper .selected_item {
  background: none;
  border: 1px solid rgba(0, 0, 0, 0.15);
}

.main-menu-list-wrapper ul {
  padding: 0;
  overflow: hidden;
}

.theme-input-select {
  height: 35px !important;
  font-size: 12px !important;
  padding: 0 !important;
  display: flex !important;
  border-color: #3A3A39;
}

.theme-label {
  font-size: 12px;
  font-weight: 600 !important;
}

.theme-label-shrink {
  margin-top: 0;
}

.theme-label-focused {
  margin-top: 0;
}

.theme-textarea {
  font-size: 14px;
  padding: 0;
}

.rv-xy-plot,
.theme-cssOutlinedInput {
  color: inherit;
}

.rv-xy-plot__axis text,
.alt-x-label text,
.alt-y-label text {
  fill: currentColor;
}

.rv-xy-plot__axis line,
.rv-xy-plot__grid-lines line {
  stroke: currentColor;
}

.theme-butotn.button-text {
  padding: 6px 16px;
}

.button-text.button-narrow {
  padding: 6px 5px;
}

.main-content-page-inner {
  padding: 20px 26px;
}

.v-checkbox {
  display: inline-block;
  width: 18px !important;
  height: 18px !important;
  text-align: center;
  border: 1px solid;
  border-radius: 3px;
}

/* .theme-notchedOutline {
  box-shadow: 0px 2px 4px 0px rgba(20, 20, 20, 0.15),
    0px 2px 4px 0px rgba(20, 20, 20, 0.15) inset;
} */
.hr-divider {
  border: 0;
  margin: 0;
  border-top: 1px solid #B2B5C466;
}

.button-small {
  min-height: 28px;
  padding-left: 16px;
  padding-right: 16px;
}

.tab-container-outer {
  padding: 0 16px 1px;
}
.tab-container-outer .tab-container-outer {
  padding: 0;
}
.tab-container-outer .custom-tabs-root {
  margin-left: -15px;
  margin-right: -15px;
  margin-top: 4px;
}

.button-with-icon {
  width: 110px;
  min-height: 124px;
  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
}
.button-with-icon span,
.button-with-icon svg {
  font-weight: normal;
  font-size: 14px;
  line-height: normal;
  text-transform: none;
  white-space: normal;
  display: block;
  margin: 0 auto 10px;
}

.driver-page-content {
  border-radius: 6px 0 0 6px;
  height: 100%;
}
.driver-page-content .leaflet-container {
  min-height: inherit;
}

.show-tracks,
.show-points {
  display: inline-flex;
  align-items: center;
  padding: 0 10px 0 0;
}

span.form-control-label,
.form-control-label {
  color: inherit;
}

.material-icons {
  vertical-align: middle;
  color: inherit;
  font-family: "Material Icons";
}

.row-value {
  font-weight: bold;
  display: inline-block;
  font-size: inherit;
}

.row-label {
  font-weight: normal;
  display: inline-block;
}

.license-card-img {
  width: 60px;
  height: 60px;
  text-align: center;
  padding: 8px;
  border-radius: 6px;
}

.attribute-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.attribute-list li {
  margin-bottom: 10px;
  border-radius: 6px;
  display: flex;
  flex-wrap: wrap;
}

.attribute-list .row-label {
  margin-bottom: 5px;
  min-width: inherit;
}

.attribute-list .row-value {
  font-weight: 700;
  font-size: 12px;
  margin-left: auto;
}

.trackers-list {
  list-style: none;
  margin: 0 0 0 -16px;
  padding: 0;
  text-align: center;
}

.trackers-list li {
  box-sizing: border-box;
  border-radius: 6px;
  width: calc(25% - 16px);
  float: left;
  margin-left: 16px;
  margin-bottom: 16px;
  padding: 0;
}

.trackers-list .row-label {
  font-size: 12px;
  font-weight: normal;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: inherit;
}

.trackers-list .row-value {
  font-size: 12px;
}

.row-image {
  width: 80px;
  height: 80px;
}

.license-card-detail p {
  display: flex;
  flex-wrap: wrap;
  margin: 10px 0;
}

.license-card-detail .row-label {
  margin-bottom: 5px;
}

.license-card-detail .row-value {
  text-align: right;
  margin-left: auto;
}

.license-card-detail {
  font-size: 12px;
  padding: 0 0 10px;
  margin-bottom: 30px;
}

.MuiSkeleton-pulse {
  animation: MuiSkeleton-keyframes-pulse 1.5s ease-in-out 0.5s infinite;
}
.skeleton-wave {
  overflow: hidden;
  position: relative;
}

.skeleton-wave::after {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  content: "";
  z-index: 1;
  position: absolute;
  animation: MuiSkeleton-keyframes-wave 2.6s linear 0.5s infinite;
  transform: translateX(-100%);
  background: linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.04), transparent);
}

.geofence-modal {
  /*   &.hide-delete-btn {
     .leaflet-draw-edit-remove {
       display: none;
     }
   }
  */
  display: flex;
}
.geofence-modal-form {
  position: relative;
  width: 245px;
  z-index: 9999;
  font-size: 12px;
  overflow: hidden;
}
.geofence-modal-form-inner {
  height: 310px;
  overflow-y: scroll;
  display: flex;
  flex: 1 1;
  flex-direction: column;
  right: -1px;
  position: relative;
}
.geofence-modal-form-inner > div {
  padding: 12px 12px 1px;
}
.geofence-modal-form-inner > div:nth-child(even) {
  background: rgba(255, 255, 255, 0.15);
}
.geofence-modal-form .ScrollbarsCustom-Wrapper {
  right: 0 !important;
}
.geofence-modal-form .ScrollbarsCustom-Content {
  padding: 12px !important;
}
.geofence-modal-form-footer {
  width: 100%;
  text-align: right;
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  padding: 10px;
}
.dialog-full-screen .geofence-modal .geofence-modal-form .geofence-modal-form-inner {
  height: calc(100% - 50px);
}
.geofence-modal-map {
  flex: 1 1;
}
.dialog-full-screen .geofence-modal {
  height: calc(100vh - 44px);
}

.notification-wizard {
  margin: 0;
  padding: 0;
}
.notification-wizard .theme-button {
  border-radius: 0;
  padding: 8px 15px;
  font-size: 15px;
  text-transform: none;
}
.notification-wizard .theme-button svg {
  display: block;
}
.notification-wizard .theme-button .row-related-icon {
  margin-left: auto;
  transform: rotate(-90deg);
}
.notification-wizard .theme-button.active .row-related-icon {
  transform: rotate(0);
}
.notification-wizard li {
  margin-top: 6px;
}

.notification-wizard-inner {
  list-style: none;
  margin: 0;
  padding: 0;
}
.notification-wizard-inner .theme-button {
  font-size: 13px;
  border-radius: 0;
  padding: 8px 15px 8px 35px;
}
.notification-wizard-inner .custom-indicator {
  background: #fff !important;
}

.unread {
  cursor: pointer;
}

.unread .read-unread-mark {
  width: 10px;
  height: 10px;
  border-radius: 10px;
  float: right;
}

.maintain-height {
  margin-top: 28px;
}

.notification-head-row {
  padding: 5px 10px;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  font-weight: bold;
  display: flex;
  align-items: center;
}

@keyframes MuiSkeleton-keyframes-wave {
  0% {
    transform: translateX(-100%);
  }
  60% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(100%);
  }
}
.skeleton-pulse {
  animation: MuiSkeleton-keyframes-pulse 1.5s ease-in-out 0.5s infinite;
}

@keyframes MuiSkeleton-keyframes-pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
}
.alert {
  padding: 6px 9px;
  border: 1px solid;
  border-radius: 4px;
  margin: 20px auto;
  font-size: 14px;
}
.alert svg {
  vertical-align: middle;
  margin-right: 6px;
}

.graph-total-unit {
  font-size: 1.5em;
  font-weight: bold;
}

.notification-model-common-section {
  padding-left: 12px;
  height: 100%;
}
.notification-model-common-section.opened {
  height: 100%;
}

.highcharts-data-label .pie-tooltip {
  display: flex;
}
.highcharts-data-label .pie-tooltip-image {
  width: 26px;
  align-items: center;
  justify-content: center;
  display: flex;
  border-radius: 4px;
  padding: 5px;
}
.highcharts-data-label .pie-tooltip-label {
  padding-left: 10px;
  font-family: Poppins, sans-serif;
  align-items: center;
  display: flex;
}
.highcharts-data-label .pie-tooltip-label b {
  font-size: 1.8em;
  font-weight: 900;
  padding-right: 7px;
}
.highcharts-data-label .pie-tooltip-half-1 .pie-tooltip-image {
  order: 1;
}
.highcharts-data-label .pie-tooltip-half-1 .pie-tooltip-label {
  order: 0;
  padding-left: 0;
  padding-right: 10px;
  text-align: right;
}

.highcharts-text-outline {
  display: none;
}

.scroll-auto {
  overflow: auto !important;
}

.scroll-visible {
  overflow: visible !important;
}

.motion-status-bar {
  display: flex;
  height: 33px;
  align-items: center;
  border-radius: 4px;
}
.motion-status-bar ~ .motion-status-bar {
  margin-top: 5px;
}
.motion-status-bar .motion-status-img {
  margin-right: 10px;
}
.motion-status-bar .motion-status-name {
  min-width: 0;
  margin-right: 10px;
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.motion-status-bar img {
  width: 20px;
  height: 20px;
}
.motion-status-bar .motion-status-border {
  width: 10px;
  border-radius: 4px;
  height: 100%;
  margin-right: 10px;
}
.motion-status-bar .motion-status-count {
  font-weight: bold;
  margin-left: auto;
  padding-right: 15px;
}
.motion-status-bar.multi-columns {
  margin-top: 5px;
  width: calc(50% - 2.5px);
}
.motion-status-bar.multi-columns .motion-status-border {
  margin-right: 8px;
}
.motion-status-bar.multi-columns .motion-status-img {
  margin-right: 8px;
}
.motion-status-bar.multi-columns .motion-status-img img {
  width: 26px;
  height: 26px;
}

.motion-status-bar2 {
  transition: all 0.2s ease;
}
.motion-status-bar2:hover {
  background: #B2B5C4 !important;
  color: #fff !important;
}

.multi-columns-wrap {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.driver-state-wrap > h3 {
  font-size: 2em;
  margin-bottom: 0;
}
.driver-state-wrap > p {
  font-size: 1.3em;
  margin: 0 0 16px;
}
.driver-state-wrap .driver-state-container {
  display: flex;
  flex: 1 1;
  flex-wrap: wrap;
  margin-left: -12px;
}
.driver-state-wrap .driver-state,
.driver-state-wrap .driver-state2 {
  width: calc(50% - 12px);
  margin-left: 12px;
  margin-bottom: 12px;
  padding: 17px 15px 10px;
  border-radius: 6px;
  text-align: center;
  color: #fff;
}
.driver-state-wrap .driver-state h3,
.driver-state-wrap .driver-state2 h3 {
  font-size: 18px;
  margin-bottom: 5px;
  margin-top: 10px;
}
.driver-state-wrap .driver-state p,
.driver-state-wrap .driver-state2 p {
  margin-top: 5px;
}
.driver-state-wrap .driver-state.online,
.driver-state-wrap .driver-state2.online {
  background: #28a745;
}
.driver-state-wrap .driver-state.offline,
.driver-state-wrap .driver-state2.offline {
  background: #dc3545;
}
.driver-state-wrap .driver-state.not-register,
.driver-state-wrap .driver-state2.not-register {
  background: #566374;
}
.driver-state-wrap .driver-state.not-update,
.driver-state-wrap .driver-state2.not-update {
  background: #1976d2;
}
.driver-state-wrap {
  /* .driver-state {
    width: calc(50% - 24px);
    margin-left: 16px;
    margin-bottom: 12px;
    padding: 10px;
    border-radius: 6px;
    img {
      margin-top: 3px;
      float: left;
    }
    h3 {
      font-size: 20px;
      margin: 0;
      margin-left: 45px;
    }
    p {
      margin-top: 0;
      margin-bottom: 0;
      margin-left: 45px;
    }
  } */
}

.button-to-normal {
  cursor: pointer;
  background: none;
  border: 0;
  color: inherit;
  font-size: 18px;
  padding: 0 0 0 10px;
  vertical-align: middle;
}

.MuiDialog-paper {
  overflow-y: visible !important;
}

.theme-range-slider {
  height: 8px !important;
}

.theme-range-slider .theme-range-slider-thumb {
  height: 24px;
  width: 24px;
  background-color: #fff;
  border: 2px solid currentColor;
  margin-top: -8px;
  margin-left: -12px;
}

.theme-range-slider .theme-range-slider-label {
  left: calc(-50% + 4px);
  top: -22px;
}

/* .theme-range-slider .theme-range-slider-label * {
  background: transparent;
} */
.theme-range-slider .theme-range-slider-rail,
.theme-range-slider .theme-range-slider-track {
  height: 8px;
  border-radius: 4px;
}

.fake-calendar {
  margin: 0;
  padding: 0;
  list-style: none;
  border-top: 1px solid rgba(0, 0, 0, 0.15);
  border-left: 1px solid rgba(0, 0, 0, 0.15);
}
.fake-calendar li {
  float: left;
  width: 20%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid rgba(0, 0, 0, 0.15);
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
}
.fake-calendar label {
  cursor: pointer;
  display: inline-block;
  width: 2em;
  height: 2em;
  text-align: center;
  line-height: 2;
  border-radius: 40px;
}
.fake-calendar .selected-day label {
  background: rgba(0, 0, 0, 0.25);
}
.fake-calendar .highlight label {
  background: rgba(0, 0, 0, 0.5);
}

.fake-calendar-result {
  float: right;
  margin-bottom: 10px;
}

.rta__autocomplete {
  color: #333;
  z-index: 99;
}

.rta__list {
  max-height: 150px;
  border: 0;
  overflow: auto;
}

.rta__entity {
  padding: 6px 12px;
  font-size: 0.8em;
}

.menu_item_text {
  color: #000;
}

.menu_item_text_inner {
  display: flex;
  text-align: left;
}

::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: rgba(255, 255, 255, 0.5);
}

::-moz-placeholder {
  /* Firefox 19+ */
  color: rgba(255, 255, 255, 0.5);
}

:-ms-input-placeholder {
  /* IE 10+ */
  color: rgba(255, 255, 255, 0.5);
}

:-moz-placeholder {
  /* Firefox 18- */
  color: rgba(255, 255, 255, 0.5);
}

.react-time-picker__clear-button {
  display: none;
}

.react-time-picker__wrapper {
  padding: 2px 10px 3px;
  border-radius: 4px;
}

.react-time-picker__inputGroup__input {
  outline: 0;
}

.messages-table {
  font-size: 12px;
}

.theme-builder-module {
  padding: 20px;
}
.theme-builder-module h1 {
  margin: 0 0 10px;
}

.step-label-root .MuiStepLabel-iconContainer {
  display: none;
}

.dnd-ebuilder-wrapper {
  padding: 16px;
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
}

.dnd-ebuilder {
  padding: 15px;
  border-radius: 6px;
}
.dnd-ebuilder h3 {
  margin-top: 4px;
  margin-bottom: 0;
}
.dnd-ebuilder h4 {
  margin-top: 5px;
  margin-bottom: 5px;
}
.dnd-ebuilder .dnd-drop {
  border: 1px dashed;
  border-radius: 6px;
  padding: 15px;
  border-radius: 6px;
  min-height: 100px;
  flex: 1 1;
}
.dnd-ebuilder .dnd-dropable {
  background: rgba(0, 0, 0, 0.15);
}
.dnd-ebuilder .tag {
  border-radius: 4px;
  padding: 6px 12px;
  margin-right: 8px;
  display: inline-block;
  vertical-align: middle;
}
.dnd-ebuilder .dropable-placehoder {
  border: 1px dashed;
  padding: 4px 12px;
  height: 2em;
  min-width: 120px;
  display: inline-block;
  vertical-align: middle;
}
.dnd-ebuilder .dnd-placeholder {
  margin-bottom: 0;
  position: relative;
}
.dnd-ebuilder .dnd-placeholder p {
  font-weight: bold;
  margin-top: 5px;
  margin-bottom: 5px;
}
.dnd-ebuilder .dnd-box {
  margin-right: 0.5rem;
  padding: 0.25rem 0.75rem;
  margin-bottom: 0.5rem;
  border-radius: 3px;
  cursor: move;
  display: inline-block;
}
.dnd-ebuilder .text-right .dnd-box {
  margin-right: 0;
  margin-left: 1rem;
}
.dnd-ebuilder .dnd-empty {
  text-align: center;
}
.dnd-ebuilder .dnd-empty h2 {
  font-size: 1em;
  margin-top: 0;
}
.dnd-ebuilder .dnd-empty svg {
  width: 40px;
}
.dnd-ebuilder .action-rollback-btn {
  position: absolute;
  top: 9px;
  right: 1px;
}

.feature-close-button {
  position: absolute;
  right: 15px;
  font-size: 24px !important;
  cursor: pointer;
}

.driver-modal-fixed,
.feature-row-1,
.feature-row {
  width: 23%;
  position: fixed;
  top: 70px;
  right: 55px;
  background-color: #ffffff;
  box-shadow: 0px 0px 1px rgba(12, 26, 75, 0.24), 0px 3px 8px -1px rgba(50, 50, 71, 0.05);
  border-radius: 8px;
  z-index: 1;
}

.driver-modal-fixed {
  left: auto;
  z-index: 9999;
  bottom: 20px;
  width: 320px;
}

.feature-row-head {
  font-weight: bold;
  font-size: 16px;
  line-height: 1.2;
  border-radius: 10px;
  padding: 8px 5px 0px 5px;
}
.feature-row-head .feature-row-head-name {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 165px;
  vertical-align: top;
}

.feature-row-inner {
  height: calc(100vh - 50px - 0 - 64px - 60px);
  font-size: 12px;
}

.feature-section {
  display: block;
  border-radius: 10px;
  line-height: 1.4;
  position: relative;
  transition: all 0.3s ease;
  padding: 20px 7px 10px;
  font-size: 0.8em;
}
.feature-section .row-label {
  margin-right: 10px;
  font-size: 12px;
}
.feature-section.alternate .row-value {
  display: block;
}
.feature-section .feature-content-section {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 3px 5px;
  background-color: #F0F4F7;
}
.feature-section .feature-content-section .item-row {
  min-width: 30%;
}
.feature-section .feature-box-Icons {
  background: #FFFFFF;
  box-shadow: 0px 0px 1px rgba(12, 26, 75, 0.24), 0px 3px 8px 0px rgba(50, 50, 71, 0.05);
  border-radius: 8px;
}
.feature-section .feature-box-Icons span {
  display: block;
  padding: 6px 18px 4px;
}
.feature-section h3 {
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 10px;
}
.feature-section {
  /* &:hover {
  	//z-index: 1;
  	//transform: scale(1.02);
  	.feature-section-close {
  		display: block;
  	}
  } */
}
.feature-section .list-unstyled {
  margin: 0;
  padding: 0;
}

.fms-notification-inner {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/****** Chat Popup Layout ******/
.msg_head,
.boxhandle-icon {
  cursor: move;
}

.msg_box {
  position: fixed;
  bottom: 30px;
  overflow: hidden;
  z-index: 9999999;
  border: 1px solid rgba(0, 0, 0, 0.5);
  background: #fff;
}

.msg_head {
  align-items: center;
  font-weight: bold;
  font-size: 12px;
  display: flex;
}
.msg_head > div {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.msg_head .msg-unit-icon {
  width: 30px;
  height: 30px;
}

.closebox {
  cursor: pointer;
  padding: 3px;
}
.closebox:hover {
  background: rgba(0, 0, 0, 0.15);
}
.closebox svg {
  fill: currentColor;
  width: 24px;
  height: 24px;
  display: block;
}

.boxhandle-icon {
  height: 10px;
}

.react-contextmenu.react-contextmenu--visible {
  min-width: 220px;
  background: #fff;
  border: solid 1px #DADCE0;
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.04);
}

.react-contextmenu .react-contextmenu-item {
  cursor: pointer;
  display: block;
  padding: 5px 40px;
  font-size: 11px;
  font-weight: normal;
  color: #202124;
}
.react-contextmenu .react-contextmenu-item--selected {
  background: #C8C8C9;
}

.collapse-report-form {
  position: absolute;
  right: 5px;
  top: 16px;
}

@media (max-width: 959px) {
  .show-tracks,
  .show-points {
    display: none;
  }
  .sensors-buttons .theme-button {
    margin: 5px !important;
  }
}
@media (max-width: 767px) {
  .license-card-img {
    float: none;
    width: auto;
  }
  .license-card-detail {
    margin-left: 0;
  }
}
@media (max-width: 479px) {
  .trackers-list li {
    width: calc(100% - 16px);
  }
}
@media (max-width: 959px) {
  .driver-page-content {
    border-radius: 6px;
  }
}
.react-base-table {
  table-layout: fixed;
  border-collapse: collapse;
}
.react-base-table .MuiTableCell-sizeSmall:last-child,
.react-base-table .MuiTableCell-sizeSmall {
  padding: 6px;
}
.react-base-table a,
.react-base-table .MuiTableCell-root {
  color: inherit;
  position: relative;
}
.react-base-table .MuiTableCell-head {
  font-weight: bold;
}
.react-base-table .MuiTableCell-body {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.react-base-table .MuiTableCell-head {
  white-space: normal;
}
.react-base-table .MuiTableCell-body a {
  display: inline-block;
  overflow: inherit;
  text-overflow: inherit;
  white-space: inherit;
}

.react-base-table-wrapper .resizer {
  display: block;
  width: 10px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
  touch-action: none;
}
.react-base-table-wrapper .resizer.isResizing {
  background: rgba(0, 0, 0, 0.05);
}
.react-base-table-wrapper .MuiPaginationItem-root,
.react-base-table-wrapper .MuiTablePagination-root,
.react-base-table-wrapper .MuiPaginationItem-root {
  color: inherit;
}
.react-base-table-wrapper .MuiTablePagination-actions .MuiIconButton-root {
  padding: 3px;
}
.react-base-table-wrapper .MuiTablePagination-toolbar {
  min-height: 40px;
}
.react-base-table-wrapper .MuiPaginationItem-root {
  height: 27px;
  min-width: 27px;
}

.btn-link {
  font-size: 0.8em;
  padding: 0 4px;
  color: currentColor;
  padding: 5px 10px;
  background: rgba(255, 255, 255, 0.25);
  margin-right: 6px;
  border-radius: 4px;
}
.btn-link.active {
  font-weight: bold;
}

.dashboard-page-header {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  padding: 16px;
  border-radius: 10px;
  font-weight: 600;
  font-size: 16px;
}
.dashboard-page-header svg {
  margin-right: 10px;
}

.device-status-box {
  cursor: pointer;
  display: flex;
  /* &.no-outline {
    padding: 0;
    border: 0;
  } */
}
.device-status-box .device-status-icon {
  color: #fff;
  width: 60px;
  height: 48px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.device-status-box .device-status-icon svg {
  display: block;
}
.device-status-box span {
  display: block;
  font-size: 16px;
  font-weight: normal;
}
.device-status-box em {
  font-style: normal;
  font-size: 12px;
  font-weight: normal;
}

.device-status-icon.online {
  background: #28a745;
}
.device-status-icon.offline {
  background: #dc3545;
}
.device-status-icon.not-register {
  background: #566374;
}
.device-status-icon.not-update {
  background: #1976d2;
}

.units-category-list {
  list-style: none;
  margin: 0;
  padding: 0;
  white-space: nowrap;
  display: flex;
  align-items: top;
  justify-content: flex-start;
}
.units-category-list li {
  cursor: pointer;
  flex-direction: column;
  margin: 0;
  display: flex;
  min-width: 80px;
  white-space: normal;
  text-align: center;
}
.units-category-list .unit-value {
  margin-top: 10px;
  font-weight: 600;
  font-size: 16px;
}
.units-category-list .unit-label {
  font-size: 12px;
  line-height: 1.3;
}

.recharts-wrapper {
  font-size: 12px;
}

.MuiIconButton-root.search-close-icon,
.search-close-icon {
  position: absolute;
  right: 6px;
  top: 10px;
}

.sensor_type_head {
  display: flex;
}

.sensor-collapse-wrapper {
  padding: 0px 13px;
  border-radius: 10px;
}

.sensor-row .sensor-row-input,
.sensor-row .sensor-row-description,
.sensor-row .sensor-row-title {
  width: 150px;
}
.sensor-row .sensor-row-actions {
  margin-left: auto;
}`, "",{"version":3,"sources":["webpack://./src/assets/main.scss","webpack://./src/assets/variables.scss"],"names":[],"mappings":"AAQA;;;;;;;sCAAA;AASA;EACE,sBAAA;AARF;;AAWA;EACE,uBAAA;EAAA,mBAAA;AARF;;AAUA;EACE,eAAA;AAPF;;AASA;EACE,SAAA;EACA,UAAA;EACA,gCC8De;ED7Df,mCAAA;EACA,kCAAA;AANF;;AAUA;EACE,6CAAA;AAPF;;AASA;EACE,6CAAA;AANF;;AAQA;EACE,6CAAA;AALF;;AAOA;EACE,6CAAA;AAJF;;AAMA;EACE,4CAAA;AAHF;;AAMA;EACE,eAAA;AAHF;;AAMA;EACE,SAAA;AAHF;;AAKA;EACE,kBAAA;AAFF;;AAKA;EACE,oBAAA;AAFF;;AAKA;EACE,+EAAA;AAFF;;AAMA;EAEE,qBAAA;AAJF;AAKE;EACE,qBAAA;AAHJ;;AAMA;EACE,gBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,gBAAA;EACA,6BAAA;AAHF;;AAKA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,WCtDW;EDuDX,eC1Ba;ED2Bb,gBCzDS;ED0DT,kBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,cC9GW;AD4Gb;;AAME;EAEE,cAAA;EACA,YAAA;EACA,WAAA;AAJJ;;AAQA;EACE,WAAA;AALF;;AAOA;EACE,YAAA;AAJF;;AAMA;EACE,eCpDa;ADiDf;;AAKA;EACE,kBAAA;AAFF;;AAIA;;EAEE,eAAA;EACA,yBAAA;EAGA,iBAAA;EACA,SAAA;AADF;;AAGA;EACE,yBAAA;EAGA,iBAAA;EACA,SAAA;AAAF;AAGE;EACE,aAAA;AADJ;AAGE;EACE,iBAAA;AADJ;AAGE;EACE,mBAAA;EACA,eAAA;EACA,qBAAA;AADJ;AAEI;EACE,YAAA;EACA,oBAAA;AAAN;AAEI;EACE,aAAA;AAAN;AAII;EACE,qBAAA;AAFN;AAII;EACE,aAAA;AAFN;;AAQA;EACE,kBAAA;AALF;AAME;EACE,+BAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,6BAAA;EACA,eAAA;AAJJ;;AAOA;EACE,mBAAA;AAJF;;AAMA;EACE,qBAAA;EACA,YAAA;AAHF;;AAKA;EACE,kBAAA;EACA,SAAA;EACA,gBCjJY;EDkJZ,iCAAA;EACA,SAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,OAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,wCAAA;EACA,UAAA;AAFF;AAGE;EACE,eAAA;EACA,WC9LQ;ED+LR,qBAAA;EACA,cAAA;AADJ;AAGM;EACE,cAAA;AADR;AAKE;;EAEE,sBAAA;EACA,qBAAA;AAHJ;AAKE;EACE,UAAA;EACA,QAAA;AAHJ;AAKE;EACE,MAAA;EACA,UAAA;AAHJ;AAKE;EACE,MAAA;EACA,WAAA;EACA,UAAA;AAHJ;AAKE;EACE,YAAA;EACA,SAAA;AAHJ;AAKE;EACE,YAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;AAHJ;AAKE;EACE,gBAAA;AAHJ;AAKE;EACE,cAAA;EACA,SAAA;AAHJ;AAII;EACE,sBAAA;EACA,iBAAA;AAFN;AAKE;EACE,iBAAA;EACA,WAAA;AAHJ;;AAMA;EACE,cAAA;AAHF;;AAKA;EACE,8CAAA;AAFF;;AAIA;;;EAGE,gBClPQ;EDmPR,cCxRW;ADuRb;;AAGA;EACE,SAAA;EACA,YAAA;EACA,mBAAA;AAAF;;AAGA;EACE,iCAAA;AAAF;;AAGA;EACE,iCAAA;AAAF;AACE;EACE,2BAAA;AACJ;;AAEA;EACE,yBAAA;AACF;;AACA;EACE,gBAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;AAEF;;AACE;EACE,eAAA;AAEJ;AAAE;EACE,aAAA;EACA,sBAAA;EACA;;KAAA;AAIJ;;AAEA;;;EAAA;AAKE;EACE,+BAAA;AAAJ;AACI;EACE,yBAAA;AACN;;AAJE;EACE,+BAAA;AAOJ;AANI;EACE,yBAAA;AAQN;;AAXE;EACE,+BAAA;AAcJ;AAbI;EACE,yBAAA;AAeN;;AAlBE;EACE,+BAAA;AAqBJ;AApBI;EACE,yBAAA;AAsBN;;AAzBE;EACE,+BAAA;AA4BJ;AA3BI;EACE,yBAAA;AA6BN;;AAhCE;EACE,+BAAA;AAmCJ;AAlCI;EACE,yBAAA;AAoCN;;AAvCE;EACE,+BAAA;AA0CJ;AAzCI;EACE,yBAAA;AA2CN;;AA9CE;EACE,+BAAA;AAiDJ;AAhDI;EACE,yBAAA;AAkDN;;AArDE;EACE,+BAAA;AAwDJ;AAvDI;EACE,yBAAA;AAyDN;;AA5DE;EACE,gCAAA;AA+DJ;AA9DI;EACE,0BAAA;AAgEN;;AAnEE;EACE,gCAAA;AAsEJ;AArEI;EACE,0BAAA;AAuEN;;AA1EE;EACE,gCAAA;AA6EJ;AA5EI;EACE,0BAAA;AA8EN;;AAjFE;EACE,gCAAA;AAoFJ;AAnFI;EACE,0BAAA;AAqFN;;AAxFE;EACE,gCAAA;AA2FJ;AA1FI;EACE,0BAAA;AA4FN;;AA/FE;EACE,gCAAA;AAkGJ;AAjGI;EACE,0BAAA;AAmGN;;AAtGE;EACE,gCAAA;AAyGJ;AAxGI;EACE,0BAAA;AA0GN;;AA7GE;EACE,gCAAA;AAgHJ;AA/GI;EACE,0BAAA;AAiHN;;AApHE;EACE,gCAAA;AAuHJ;AAtHI;EACE,0BAAA;AAwHN;;AA3HE;EACE,gCAAA;AA8HJ;AA7HI;EACE,0BAAA;AA+HN;;AAlIE;EACE,gCAAA;AAqIJ;AApII;EACE,0BAAA;AAsIN;;AAzIE;EACE,gCAAA;AA4IJ;AA3II;EACE,0BAAA;AA6IN;;AAhJE;EACE,gCAAA;AAmJJ;AAlJI;EACE,0BAAA;AAoJN;;AAvJE;EACE,gCAAA;AA0JJ;AAzJI;EACE,0BAAA;AA2JN;;AA9JE;EACE,gCAAA;AAiKJ;AAhKI;EACE,0BAAA;AAkKN;;AArKE;EACE,gCAAA;AAwKJ;AAvKI;EACE,0BAAA;AAyKN;;AA5KE;EACE,gCAAA;AA+KJ;AA9KI;EACE,0BAAA;AAgLN;;AAnLE;EACE,gCAAA;AAsLJ;AArLI;EACE,0BAAA;AAuLN;;AA1LE;EACE,gCAAA;AA6LJ;AA5LI;EACE,0BAAA;AA8LN;;AAjME;EACE,gCAAA;AAoMJ;AAnMI;EACE,0BAAA;AAqMN;;AAxME;EACE,gCAAA;AA2MJ;AA1MI;EACE,0BAAA;AA4MN;;AA/ME;EACE,gCAAA;AAkNJ;AAjNI;EACE,0BAAA;AAmNN;;AAtNE;EACE,gCAAA;AAyNJ;AAxNI;EACE,0BAAA;AA0NN;;AA7NE;EACE,gCAAA;AAgOJ;AA/NI;EACE,0BAAA;AAiON;;AApOE;EACE,gCAAA;AAuOJ;AAtOI;EACE,0BAAA;AAwON;;AA3OE;EACE,gCAAA;AA8OJ;AA7OI;EACE,0BAAA;AA+ON;;AAlPE;EACE,gCAAA;AAqPJ;AApPI;EACE,0BAAA;AAsPN;;AAzPE;EACE,gCAAA;AA4PJ;AA3PI;EACE,0BAAA;AA6PN;;AAhQE;EACE,gCAAA;AAmQJ;AAlQI;EACE,0BAAA;AAoQN;;AAvQE;EACE,gCAAA;AA0QJ;AAzQI;EACE,0BAAA;AA2QN;;AA9QE;EACE,gCAAA;AAiRJ;AAhRI;EACE,0BAAA;AAkRN;;AArRE;EACE,gCAAA;AAwRJ;AAvRI;EACE,0BAAA;AAyRN;;AA5RE;EACE,gCAAA;AA+RJ;AA9RI;EACE,0BAAA;AAgSN;;AAnSE;EACE,gCAAA;AAsSJ;AArSI;EACE,0BAAA;AAuSN;;AA1SE;EACE,gCAAA;AA6SJ;AA5SI;EACE,0BAAA;AA8SN;;AAjTE;EACE,gCAAA;AAoTJ;AAnTI;EACE,0BAAA;AAqTN;;AAxTE;EACE,gCAAA;AA2TJ;AA1TI;EACE,0BAAA;AA4TN;;AA/TE;EACE,gCAAA;AAkUJ;AAjUI;EACE,0BAAA;AAmUN;;AAtUE;EACE,gCAAA;AAyUJ;AAxUI;EACE,0BAAA;AA0UN;;AA7UE;EACE,gCAAA;AAgVJ;AA/UI;EACE,0BAAA;AAiVN;;AApVE;EACE,gCAAA;AAuVJ;AAtVI;EACE,0BAAA;AAwVN;;AA3VE;EACE,gCAAA;AA8VJ;AA7VI;EACE,0BAAA;AA+VN;;AAlWE;EACE,gCAAA;AAqWJ;AApWI;EACE,0BAAA;AAsWN;;AAzWE;EACE,gCAAA;AA4WJ;AA3WI;EACE,0BAAA;AA6WN;;AAhXE;EACE,gCAAA;AAmXJ;AAlXI;EACE,0BAAA;AAoXN;;AAvXE;EACE,gCAAA;AA0XJ;AAzXI;EACE,0BAAA;AA2XN;;AA9XE;EACE,gCAAA;AAiYJ;AAhYI;EACE,0BAAA;AAkYN;;AArYE;EACE,gCAAA;AAwYJ;AAvYI;EACE,0BAAA;AAyYN;;AA5YE;EACE,gCAAA;AA+YJ;AA9YI;EACE,0BAAA;AAgZN;;AAnZE;EACE,gCAAA;AAsZJ;AArZI;EACE,0BAAA;AAuZN;;AA1ZE;EACE,gCAAA;AA6ZJ;AA5ZI;EACE,0BAAA;AA8ZN;;AAxZE;EACE;;;;;;;KAAA;AAkaJ;AAnZI;EACE,iBAAA;AAqZN;AAnZI;EACE,iBAAA;AAqZN;;AAzaE;EACE;;;;;;;KAAA;AAmbJ;AApaI;EACE,kBAAA;AAsaN;AApaI;EACE,kBAAA;AAsaN;;AA1bE;EACE;;;;;;;KAAA;AAocJ;AArbI;EACE,kBAAA;AAubN;AArbI;EACE,kBAAA;AAubN;;AA3cE;EACE;;;;;;;KAAA;AAqdJ;AAtcI;EACE,kBAAA;AAwcN;AAtcI;EACE,kBAAA;AAwcN;;AA5dE;EACE;;;;;;;KAAA;AAseJ;AAvdI;EACE,kBAAA;AAydN;AAvdI;EACE,kBAAA;AAydN;;AA7eE;EACE;;;;;;;KAAA;AAufJ;AAxeI;EACE,kBAAA;AA0eN;AAxeI;EACE,kBAAA;AA0eN;;AA9fE;EACE;;;;;;;KAAA;AAwgBJ;AAzfI;EACE,kBAAA;AA2fN;AAzfI;EACE,kBAAA;AA2fN;;AA/gBE;EACE;;;;;;;KAAA;AAyhBJ;AA1gBI;EACE,kBAAA;AA4gBN;AA1gBI;EACE,kBAAA;AA4gBN;;AAhiBE;EACE;;;;;;;KAAA;AA0iBJ;AA3hBI;EACE,kBAAA;AA6hBN;AA3hBI;EACE,kBAAA;AA6hBN;;AAjjBE;EACE;;;;;;;KAAA;AA2jBJ;AA5iBI;EACE,kBAAA;AA8iBN;AA5iBI;EACE,kBAAA;AA8iBN;;AAlkBE;EACE;;;;;;;KAAA;AA4kBJ;AA7jBI;EACE,mBAAA;AA+jBN;AA7jBI;EACE,mBAAA;AA+jBN;;AAnlBE;EACE;;;;;;;KAAA;AA6lBJ;AA9kBI;EACE,mBAAA;AAglBN;AA9kBI;EACE,mBAAA;AAglBN;;AApmBE;EACE;;;;;;;KAAA;AA8mBJ;AA/lBI;EACE,mBAAA;AAimBN;AA/lBI;EACE,mBAAA;AAimBN;;AArnBE;EACE;;;;;;;KAAA;AA+nBJ;AAhnBI;EACE,mBAAA;AAknBN;AAhnBI;EACE,mBAAA;AAknBN;;AAtoBE;EACE;;;;;;;KAAA;AAgpBJ;AAjoBI;EACE,mBAAA;AAmoBN;AAjoBI;EACE,mBAAA;AAmoBN;;AAvpBE;EACE;;;;;;;KAAA;AAiqBJ;AAlpBI;EACE,mBAAA;AAopBN;AAlpBI;EACE,mBAAA;AAopBN;;AAxqBE;EACE;;;;;;;KAAA;AAkrBJ;AAnqBI;EACE,mBAAA;AAqqBN;AAnqBI;EACE,mBAAA;AAqqBN;;AAzrBE;EACE;;;;;;;KAAA;AAmsBJ;AAprBI;EACE,mBAAA;AAsrBN;AAprBI;EACE,mBAAA;AAsrBN;;AA1sBE;EACE;;;;;;;KAAA;AAotBJ;AArsBI;EACE,mBAAA;AAusBN;AArsBI;EACE,mBAAA;AAusBN;;AA3tBE;EACE;;;;;;;KAAA;AAquBJ;AAttBI;EACE,mBAAA;AAwtBN;AAttBI;EACE,mBAAA;AAwtBN;;AA5uBE;EACE;;;;;;;KAAA;AAsvBJ;AAvuBI;EACE,mBAAA;AAyuBN;AAvuBI;EACE,mBAAA;AAyuBN;;AA7vBE;EACE;;;;;;;KAAA;AAuwBJ;AAxvBI;EACE,mBAAA;AA0vBN;AAxvBI;EACE,mBAAA;AA0vBN;;AA9wBE;EACE;;;;;;;KAAA;AAwxBJ;AAzwBI;EACE,mBAAA;AA2wBN;AAzwBI;EACE,mBAAA;AA2wBN;;AA/xBE;EACE;;;;;;;KAAA;AAyyBJ;AA1xBI;EACE,mBAAA;AA4xBN;AA1xBI;EACE,mBAAA;AA4xBN;;AAhzBE;EACE;;;;;;;KAAA;AA0zBJ;AA3yBI;EACE,mBAAA;AA6yBN;AA3yBI;EACE,mBAAA;AA6yBN;;AAj0BE;EACE;;;;;;;KAAA;AA20BJ;AA5zBI;EACE,mBAAA;AA8zBN;AA5zBI;EACE,mBAAA;AA8zBN;;AAl1BE;EACE;;;;;;;KAAA;AA41BJ;AA70BI;EACE,mBAAA;AA+0BN;AA70BI;EACE,mBAAA;AA+0BN;;AAn2BE;EACE;;;;;;;KAAA;AA62BJ;AA91BI;EACE,mBAAA;AAg2BN;AA91BI;EACE,mBAAA;AAg2BN;;AAp3BE;EACE;;;;;;;KAAA;AA83BJ;AA/2BI;EACE,mBAAA;AAi3BN;AA/2BI;EACE,mBAAA;AAi3BN;;AAr4BE;EACE;;;;;;;KAAA;AA+4BJ;AAh4BI;EACE,mBAAA;AAk4BN;AAh4BI;EACE,mBAAA;AAk4BN;;AAt5BE;EACE;;;;;;;KAAA;AAg6BJ;AAj5BI;EACE,mBAAA;AAm5BN;AAj5BI;EACE,mBAAA;AAm5BN;;AAh4BA;EACE,gBAAA;AAm4BF;;AAj4BA;EAEE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;EAEA,YAAA;EAEA,sBAAA;EAEA;;;;;;;KAAA;EAQA,aAAA;AAg4BF;;AA73BE;EACE,cAAA;AAg4BJ;;AA53BA;EACE,gBAAA;EACA,SAAA;AA+3BF;AA93BE;EACE,0BAAA;EACA,YAAA;AAg4BJ;;AA53BA;EACE,wBAAA;AA+3BF;;AA53BA;EACE,mBAAA;AA+3BF;;AA53BA;EACE,yBAAA;EACA,cCtaW;EDuaX,gBAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;AA+3BF;;AA33BE;;EAEE,iBAAA;AA83BJ;;AA33BA;EACE,iBAAA;AA83BF;;AA33BA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AA83BF;;AA53BA;EACE,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AA+3BF;;AA73BA;EACE,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;AAg4BF;;AA73BE;EACE,eAAA;AAg4BJ;;AA73BA;EACE,kBAAA;AAg4BF;;AA93BA;EACE,aAAA;EACA,aAAA;AAi4BF;AA/3BE;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;AAi4BJ;AA/3BE;EACE,0BAAA;EACA,iBAAA;AAi4BJ;AA/3BE;EACE,gBAAA;AAi4BJ;;AA73BA;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,0CAAA;AAg4BF;;AA93BA;EACE,iBAAA;AAi4BF;;AA93BA;EACE,iBAAA;AAi4BF;;AA93BA;EACE,uBAAA;AAi4BF;;AA/3BA;EACE,0BAAA;EACA,4BAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,qBAAA;EACA,qBAAA;AAk4BF;;AAh4BA;;EAEE,8BAAA;EACA,gCAAA;EACA,sBAAA;AAm4BF;;AAj4BA;;EAEE,8BAAA;EACA,gCAAA;EACA,sBAAA;AAo4BF;;AAl4BA;;EAEE,8BAAA;EACA,gCAAA;EACA,sBAAA;AAq4BF;;AAn4BA;EACE,8BAAA;EACA,gCAAA;EACA,sBAAA;AAs4BF;;AAp4BA;EACE,sBAAA;AAu4BF;;AAr4BA;EACE,sBAAA;EACA,4BAAA;EACA,0BAAA;EACA,yBAAA;EACA,iBAAA;EACA,6BAAA;EACA,uDAAA;EACA,sIAAA;AAw4BF;AAr4BI;EACE,cAAA;AAu4BN;;AAl4BA;EACE,kBAAA;EACA,wBAAA;EACA,sBAAA;AAq4BF;;AAl4BA;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AAq4BF;;AAl4BA;EACE,cAAA;AAq4BF;;AAl4BA;EACE;IACE,0BAAA;EAq4BF;EAn4BA;IACE,2BAAA;IACA,mBAAA;IACA,kBAAA;IACA,UAAA;EAq4BF;AACF;AAl4BA;EACE,kBAAA;AAo4BF;;AAl4BA;EACE,gBAAA;AAq4BF;;AAn4BA;EACE,iBAAA;AAs4BF;;AAn4BA;EACE,cAAA;AAs4BF;;AAj4BI;EACE,mBAAA;AAo4BN;AAl4BI;EACE,gBAAA;EACA,qCAAA;AAo4BN;;AA/3BA;EACE,UAAA;EACA,gBAAA;AAk4BF;;AA/3BA;EACE,uBAAA;EACA,0BAAA;EACA,qBAAA;EACA,wBAAA;EACA,qBAAA;AAk4BF;;AA/3BA;EACE,eAAA;EACA,2BAAA;AAk4BF;;AA/3BA;EACE,aAAA;AAk4BF;;AAh4BA;EACE,aAAA;AAm4BF;;AAh4BA;EACE,eAAA;EACA,UAAA;AAm4BF;;AAj4BA;;EAEE,cAAA;AAo4BF;;AAl4BA;;;EAGE,kBAAA;AAq4BF;;AAn4BA;;EAEE,oBAAA;AAs4BF;;AAn4BA;EACE,iBAAA;AAs4BF;;AAn4BA;EACE,gBAAA;AAs4BF;;AAn4BA;EACE,kBAAA;AAs4BF;;AAp4BA;EACE,qBAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AAu4BF;;AAr4BA;;;GAAA;AAKA;EACE,SAAA;EACA,SAAA;EACA,+BAAA;AAu4BF;;AAp4BA;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;AAu4BF;;AAp4BA;EACE,mBAAA;AAu4BF;AAt4BE;EACE,UAAA;AAw4BJ;AAt4BE;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;AAw4BJ;;AAp4BA;EACE,YAAA;EACA,iBAAA;EACA,2HAAA;AAu4BF;AAp4BE;;EAEE,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;AAs4BJ;;AAl4BA;EACE,0BAAA;EACA,YAAA;AAq4BF;AAp4BE;EACE,mBAAA;AAs4BJ;;AAl4BA;;EAEE,oBAAA;EACA,mBAAA;EACA,mBAAA;AAq4BF;;AAn4BA;;EAEE,cAAA;AAs4BF;;AAn4BA;EACE,sBAAA;EACA,cAAA;EACA,6BAAA;AAs4BF;;AAp4BA;EACE,iBAAA;EACA,qBAAA;EAEA,kBAAA;AAs4BF;;AAp4BA;EACE,mBAAA;EACA,qBAAA;AAu4BF;;AAr4BA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AAw4BF;;AAt4BA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;AAy4BF;;AAv4BA;EACE,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;AA04BF;;AAv4BA;EACE,kBAAA;EACA,kBAAA;AA04BF;;AAx4BA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AA24BF;;AAz4BA;EACE,gBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;AA44BF;;AA14BA;EACE,sBAAA;EACA,kBAAA;EACA,uBAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,UAAA;AA64BF;;AA34BA;EACE,eAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AA84BF;;AA54BA;EACE,eAAA;AA+4BF;;AA74BA;EACE,WAAA;EACA,YAAA;AAg5BF;;AA74BA;EACE,aAAA;EACA,eAAA;EACA,cAAA;AAg5BF;;AA94BA;EACE,kBAAA;AAi5BF;;AA/4BA;EACE,iBAAA;EACA,iBAAA;AAk5BF;;AAh5BA;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;AAm5BF;;AAh5BA;EACE,qEAAA;AAm5BF;AAt4BA;EACE,gBAAA;EACA,kBAAA;AAo5BF;;AAl5BA;EACE,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,+DAAA;EACA,4BAAA;EACA,iFAAA;AAq5BF;;AA74BA;EACE;;;;;GAAA;EAMA,aAAA;AAg5BF;AA/4BE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;AAi5BJ;AAh5BI;EACE,aAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;AAk5BN;AAj5BM;EACE,sBAAA;AAm5BR;AAl5BQ;EACE,qCAAA;AAo5BV;AAh5BI;EACE,mBAAA;AAk5BN;AAh5BI;EACE,wBAAA;AAk5BN;AAh5BI;EACE,WAAA;EACA,iBAAA;EACA,+CAAA;EACA,aAAA;AAk5BN;AA94BI;EACE,yBAAA;AAg5BN;AA74BE;EACE,SAAA;AA+4BJ;AA54BE;EACE,0BAAA;AA84BJ;;AA34BA;EACE,SAAA;EACA,UAAA;AA84BF;AA74BE;EACE,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;AA+4BJ;AA94BI;EACE,cAAA;AAg5BN;AA94BI;EACE,iBAAA;EACA,yBAAA;AAg5BN;AA74BM;EACE,oBAAA;AA+4BR;AA34BE;EACE,eAAA;AA64BJ;;AA14BA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;AA64BF;AA54BE;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;AA84BJ;AA54BE;EACE,2BAAA;AA84BJ;;AAx4BA;EACE,eAAA;AA24BF;;AAz4BA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;AA44BF;;AAz4BA;EACE,gBAAA;AA44BF;;AA14BA;EACE,iBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;AA64BF;;AAz4BA;EACE;IACE,4BAAA;EA44BF;EA14BA;IACE,2BAAA;EA44BF;EA14BA;IACE,2BAAA;EA44BF;AACF;AA14BA;EACE,qEAAA;AA44BF;;AA14BA;EACE;IACE,UAAA;EA64BF;EA34BA;IACE,YAAA;EA64BF;EA34BA;IACE,UAAA;EA64BF;AACF;AA14BA;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eCv7Ba;ADm0Df;AA34BE;EACE,sBAAA;EACA,iBAAA;AA64BJ;;AAz4BA;EACE,gBAAA;EACA,iBAAA;AA44BF;;AA14BA;EACE,kBAAA;EACA,YAAA;AA64BF;AA54BE;EACE,YAAA;AA84BJ;;AA14BE;EACE,aAAA;AA64BJ;AA54BI;EACE,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;AA84BN;AA54BI;EACE,kBAAA;EACA,gCCz8BW;ED08BX,mBAAA;EACA,aAAA;AA84BN;AA74BM;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;AA+4BR;AA14BI;EACE,QAAA;AA44BN;AA14BI;EACE,QAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;AA44BN;;AAx4BA;EACE,aAAA;AA24BF;;AAz4BA;EACE,yBAAA;AA44BF;;AA14BA;EACE,4BAAA;AA64BF;;AA34BA;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AA84BF;AA74BE;EACE,eAAA;AA+4BJ;AA74BE;EACE,kBAAA;AA+4BJ;AA74BE;EACE,YAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA+4BJ;AA74BE;EACE,WAAA;EACA,YAAA;AA+4BJ;AA74BE;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AA+4BJ;AA74BE;EACE,iBAAA;EACA,iBAAA;EACA,mBAAA;AA+4BJ;AA74BE;EACE,eAAA;EACA,wBAAA;AA+4BJ;AA94BI;EACE,iBAAA;AAg5BN;AA94BI;EACE,iBAAA;AAg5BN;AA/4BM;EACE,WAAA;EACA,YAAA;AAi5BR;;AA54BA;EACE,yBAAA;AA+4BF;AA94BE;EACE,8BAAA;EACA,sBAAA;AAg5BJ;;AA54BA;EACE,aAAA;EACA,8BAAA;EACA,eAAA;AA+4BF;;AA34BE;EACE,cAAA;EACA,gBAAA;AA84BJ;AA54BE;EACE,gBAAA;EACA,gBAAA;AA84BJ;AA54BE;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;AA84BJ;AA54BE;;EAEE,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AA84BJ;AA74BI;;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;AAg5BN;AA94BI;;EACE,eAAA;AAi5BN;AA/4BI;;EACE,mBAAA;AAk5BN;AAh5BI;;EACE,mBAAA;AAm5BN;AAj5BI;;EACE,mBAAA;AAo5BN;AAl5BI;;EACE,mBAAA;AAq5BN;AA/7BA;EA6CE;;;;;;;;;;;;;;;;;;;;KAAA;AAy6BF;;AAl5BA;EACE,eAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;AAq5BF;;AAl5BA;EACE,8BAAA;AAq5BF;;AAl5BA;EACE,sBAAA;AAq5BF;;AAn5BA;EACE,YAAA;EACA,WAAA;EACA,sBAAA;EACA,8BAAA;EACA,gBAAA;EACA,kBAAA;AAs5BF;;AAp5BA;EACE,sBAAA;EACA,UAAA;AAu5BF;;AAp5BA;;GAAA;AAGA;;EAEE,WAAA;EACA,kBAAA;AAu5BF;;AAp5BA;EACE,SAAA;EACA,UAAA;EACA,gBAAA;EACA,yCAAA;EACA,0CAAA;AAu5BF;AAt5BE;EACE,WAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2CAAA;EACA,4CAAA;AAw5BJ;AAt5BE;EACE,eAAA;EACA,qBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AAw5BJ;AAt5BE;EACE,+BAAA;AAw5BJ;AAt5BE;EACE,8BAAA;AAw5BJ;;AAr5BA;EACE,YAAA;EACA,mBAAA;AAw5BF;;AAr5BA;EACE,WAAA;EACA,WAAA;AAw5BF;;AAt5BA;EACE,iBAAA;EACA,SAAA;EACA,cAAA;AAy5BF;;AAt5BA;EACE,iBAAA;EACA,gBAAA;AAy5BF;;AAv5BA;EACE,WAAA;AA05BF;;AAv5BA;EACE,aAAA;EACA,gBAAA;AA05BF;;AAx5BA;EACE,wBAAA;EACA,+BAAA;AA25BF;;AAz5BA;EACE,gBAAA;EACA,+BAAA;AA45BF;;AA15BA;EACE,WAAA;EACA,+BAAA;AA65BF;;AA35BA;EACE,gBAAA;EACA,+BAAA;AA85BF;;AA55BA;EACE,aAAA;AA+5BF;;AA55BA;EACE,qBAAA;EACA,kBAAA;AA+5BF;;AA75BA;EACE,UAAA;AAg6BF;;AA75BA;EACE,eAAA;AAg6BF;;AA55BA;EACE,aAAA;AA+5BF;AA95BE;EACE,gBAAA;AAg6BJ;;AA15BE;EACE,aAAA;AA65BJ;;AAz5BA;EACE,aAAA;EACA,yHAAA;AA45BF;;AA15BA;EACE,aAAA;EACA,kBAAA;AA65BF;AA55BE;EACE,eAAA;EACA,gBAAA;AA85BJ;AA55BE;EACE,eAAA;EACA,kBAAA;AA85BJ;AA35BE;EACE,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,SAAA;AA65BJ;AA15BE;EACE,+BAAA;AA45BJ;AAz5BE;EACE,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;AA25BJ;AAx5BE;EACE,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;AA05BJ;AAx5BE;EACE,gBAAA;EACA,kBAAA;AA05BJ;AAz5BI;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;AA25BN;AAv5BE;EACE,oBAAA;EACA,wBAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;AAy5BJ;AAt5BE;EACE,eAAA;EACA,iBAAA;AAw5BJ;AAr5BE;EACE,kBAAA;AAu5BJ;AAt5BI;EACE,cAAA;EACA,aAAA;AAw5BN;AAt5BI;EACE,WAAA;AAw5BN;AAp5BE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;AAs5BJ;;AAj5BA;EACE,kBAAA;EAGA,WAAA;EAEA,0BAAA;EACA,eAAA;AAi5BF;;AA54BA;;;EAIE,UAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;EAEA,uFAAA;EACA,kBAAA;EAEC,UAAA;AA44BH;;AAz4BA;EACE,UAAA;EACA,aAAA;EACA,YAAA;EACA,YC/7Cc;AD20EhB;;AAt4BA;EAEE,iBAAA;EACA,eAAA;EACA,gBAAA;EAEA,mBAAA;EACA,wBAAA;AAu4BF;AAt4BE;EACE,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AAw4BJ;;AAr4BA;EACE,4CAAA;EACA,eAAA;AAw4BF;;AAr4BA;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;AAw4BF;AAt4BE;EACE,kBAAA;EACA,eAAA;AAw4BJ;AAt4BE;EAEE,cAAA;AAu4BJ;AAp4BE;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,gBAAA;EACA,yBAAA;AAs4BJ;AAr4BI;EACE,cAAA;AAu4BN;AAp4BE;EACE,mBAAA;EACA,sFAAA;EACA,kBAAA;AAs4BJ;AAr4BI;EACE,cAAA;EACA,qBAAA;AAu4BN;AAn4BE;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;AAq4BJ;AA96BA;EA2CE;;;;;;KAAA;AA44BF;AAr4BE;EACE,SAAA;EACA,UAAA;AAu4BJ;;AAl4BA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AAq4BF;;AA/3BA,gCAAA;AACA;;EAEE,YAAA;AAk4BF;;AAh4BA;EACE,eAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,oCAAA;EACA,gBAAA;AAm4BF;;AAj4BA;EACE,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;AAo4BF;AAn4BE;EACE,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAq4BJ;AAn4BE;EACE,WAAA;EACA,YAAA;AAq4BJ;;AAl4BA;EACE,eAAA;EACA,YAAA;AAq4BF;AAp4BE;EACE,+BAAA;AAs4BJ;AAp4BE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAs4BJ;;AAn4BA;EACE,YAAA;AAs4BF;;AAn4BA;EACE,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,2CAAA;AAs4BF;;AAn4BE;EACE,eAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AAs4BJ;AAn4BE;EACE,mBAAA;AAq4BJ;;AAh4BA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;AAm4BF;;AA73BA;EACE;;IAEE,aAAA;EAg4BF;EA53BE;IACE,sBAAA;EA83BJ;AACF;AA13BA;EACE;IACE,WAAA;IACA,WAAA;EA43BF;EA13BA;IACE,cAAA;EA43BF;AACF;AA13BA;EACE;IACE,wBAAA;EA43BF;AACF;AAz3BA;EACE;IACE,kBAAA;EA23BF;AACF;AAx3BA;EACE,mBAAA;EACA,yBAAA;AA03BF;AAz3BE;;EAEE,YAAA;AA23BJ;AAz3BE;;EAEE,cAAA;EACA,kBAAA;AA23BJ;AAz3BE;EACE,iBAAA;AA23BJ;AAz3BE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AA23BJ;AAz3BE;EACE,mBAAA;AA23BJ;AAz3BE;EACE,qBAAA;EACA,iBAAA;EACA,sBAAA;EACA,oBAAA;AA23BJ;;AAt3BE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,UAAA;EACA,kBAAA;AAy3BJ;AAv3BI;EACE,+BAAA;AAy3BN;AAt3BE;;;EAGE,cAAA;AAw3BJ;AAr3BE;EACE,YAAA;AAu3BJ;AAr3BE;EACE,gBAAA;AAu3BJ;AAr3BE;EACE,YAAA;EACA,eAAA;AAu3BJ;;AAl3BA;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,qCAAA;EACA,iBAAA;EACA,kBAAA;AAq3BF;AAp3BE;EACE,iBAAA;AAs3BJ;;AAl3BA;EACE,yCAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AAq3BF;AAp3BE;EACE,kBAAA;AAs3BJ;;AAl3BA;EACE,eAAA;EAMA,aAAA;EACA;;;KAAA;AAm3BF;AA/2BE;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAi3BJ;AAh3BI;EACE,cAAA;AAk3BN;AA/2BE;EACE,cAAA;EACA,eAAA;EACA,mBAAA;AAi3BJ;AA/2BE;EACE,kBAAA;EACA,eAAA;EACA,mBAAA;AAi3BJ;;AA52BE;EACE,mBAAA;AA+2BJ;AA72BE;EACE,mBAAA;AA+2BJ;AA72BE;EACE,mBAAA;AA+2BJ;AA72BE;EACE,mBAAA;AA+2BJ;;AA32BA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,2BAAA;AA82BF;AA72BE;EACE,eAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AA+2BJ;AA72BE;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;AA+2BJ;AA72BE;EACE,eAAA;EACA,gBAAA;AA+2BJ;;AA32BA;EAAmB,eAAA;AA+2BnB;;AA72BA;;EAEE,kBAAA;EACA,UAAA;EACA,SAAA;AAg3BF;;AA72BA;EACE,aAAA;AAg3BF;;AA72BA;EACE,iBAAA;EACA,mBAAA;AAg3BF;;AAt2BE;;;EAGE,YAAA;AAy2BJ;AAv2BE;EACE,iBAAA;AAy2BJ","sourcesContent":["// =====================================================\n// =====================================================\n// =====================================================\n//                      BASE\n// =====================================================\n// =====================================================\n// =====================================================\n@import './variables';\n/* @import \"./components/reboot\";\n@import \"./components/grid\";\n@import \"./components/type\";\n@import \"./components/buttons\";\n@import \"./components/forms\";\n@import \"./components/input-group\";\n@import \"./components/text\";\n@import \"./components/custom-forms\"; */\n\n* {\n  box-sizing: border-box;\n}\n\n.material-icons {\n  box-sizing: initial;\n}\nhtml {\n  font-size: 14px;\n}\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: $baseFontFamily;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  // background: url('/assets/images/main-bg.png');\n}\n\n.ff-1 {\n  font-family: 'Poppins', sans-serif !important;\n}\n.ff-2 {\n  font-family: 'PT Sans', sans-serif !important;\n}\n.ff-3 {\n  font-family: 'Raleway', sans-serif !important;\n}\n.ff-4 {\n  font-family: 'Poppins', sans-serif !important; // 'Roboto', sans-serif !important;\n}\n.ff-5 {\n  font-family: 'Nunito', sans-serif !important;\n}\n\n.hover {\n  cursor: pointer;\n}\n\n.no-margin {\n  margin: 0;\n}\n.mb-5 {\n  margin-bottom: 5px;\n}\n\n.leaflet-container {\n  font-family: inherit;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\na {\n  //color: $themeColor;\n  text-decoration: none;\n  &:hover {\n    text-decoration: none;\n  }\n}\n.list-unstyled {\n  list-style: none;\n}\n\n.montoring-addres{\n  font-style: italic;\n  font-size: 11px;\n  font-weight:400;\n  padding: 0 5px;\n  color:#27272E;\n  max-Width:90%;\n  height: 2.6em; // limit the height to two lines\n  line-height: 1.3em; // set the line height to match the font size\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  margin: 11px 0px;\n  -webkit-box-orientt: vertical; \n  }\n.badge {\n  display: inline-block;\n  width: 1.2em;\n  height: 1.2em;\n  line-height: 1.2em;\n  color: $badgeColor;\n  font-size: $baseFontSize;\n  background: $badgeBgColor;\n  text-align: center;\n  border-radius: 50%;\n}\n\n.text-theme {\n  color: $themeColor;\n}\n\n.clearfix {\n  &:before,\n  &:after {\n    display: table;\n    content: ' ';\n    clear: both;\n  }\n}\n\n.pull-left {\n  float: left;\n}\n.pull-right {\n  float: right;\n}\n.text-normal {\n  font-size: $baseFontSize;\n}\n.v-hidden {\n  visibility: hidden;\n}\n.form-check-label label,\n.form-check-label {\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  margin: 0;\n}\n.checkbox {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  margin: 0;\n  //color: #999;\n\n  input {\n    display: none;\n  }\n  .form-check-inline & input + span {\n    margin-right: 5px;\n  }\n  input + span {\n    vertical-align: top;\n    font-size: 14px;\n    display: inline-block;\n    span {\n      height: auto;\n      line-height: inherit;\n    }\n    .on-active {\n      display: none;\n    }\n  }\n  input:checked {\n    + span .on-active {\n      display: inline-block;\n    }\n    + span .on-inactive {\n      display: none;\n    }\n  }\n}\n\n// sub menu\n.has-menu {\n  position: relative;\n  .has-menu > a:after {\n    content: 'keyboard_arrow_right';\n    display: block;\n    position: absolute;\n    right: 0;\n    top: 0;\n    font-family: 'Material Icons';\n    font-size: 20px;\n  }\n}\n.horizontal-menu ul {\n  white-space: nowrap;\n}\n.horizontal-menu li {\n  display: inline-block;\n  height: auto;\n}\n.sub-menu {\n  position: absolute;\n  top: 100%;\n  background: $dropdown-bg;\n  border-top: 3px solid $hoverBorderColor;\n  margin: 0;\n  margin-top: -3px;\n  padding: 0;\n  list-style: none;\n  min-width: 180px;\n  left: 0;\n  display: none;\n  text-align: left;\n  line-height: 1.4;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);\n  z-index: 9;\n  li a {\n    font-size: 12px;\n    color: $textColor;\n    text-decoration: none;\n    display: block;\n    &:hover {\n      .rel-icons {\n        color: inherit;\n      }\n    }\n  }\n  label span,\n  a span {\n    vertical-align: middle;\n    display: inline-block;\n  }\n  &.right-menu {\n    left: auto;\n    right: 0;\n  }\n  &.level-right {\n    top: 0;\n    left: 100%;\n  }\n  &.level-left {\n    top: 0;\n    right: 100%;\n    left: auto;\n  }\n  &.left-top {\n    bottom: 100%;\n    top: auto;\n  }\n  &.right-top {\n    bottom: 100%;\n    top: auto;\n    right: 0;\n    left: auto;\n  }\n  a {\n    padding: 6px 9px;\n  }\n  label {\n    display: block;\n    margin: 0;\n    input {\n      vertical-align: middle;\n      margin-right: 5px;\n    }\n  }\n  .rel-icons {\n    margin-right: 5px;\n    color: #aaa;\n  }\n}\n:hover > .sub-menu {\n  display: block;\n}\n.divider {\n  border-top: 1px solid $dropdown-border;\n}\n.sub-menu label:hover,\n.sub-menu .active a,\n.sub-menu a:hover {\n  background: $subMenuHoverBg;\n  color: $subMenuHoverColor;\n}\n.center-menu {\n  left: 50%;\n  width: 340px;\n  margin-left: -340 / 2 * 1px;\n}\n\n.marker {\n  transition: transform 0.4s linear;\n}\n\n.leaflet-tooltip.has-animation {\n  transition: transform 0.4s linear;\n  img {\n    transition: all 0.4s linear;\n  }\n}\n.color-inherit {\n  color: inherit !important;\n}\n.selector-count {\n  padding: 0 0 6px;\n  font-size: 10px;\n  display: flex;\n  justify-content: space-between\n}\n.geofences-columns-wise {\n  .ScrollbarsCustom-Wrapper {\n    margin: 0 -15px;\n  }\n  .geoList {\n    display: flex;\n    flex-direction: column;\n    /* .list-row-1 {\n       width: 49%;\n    } */\n  }\n}\n\n/* .custom-tabs .Mui-disabled {\n  display: none;\n}\n */\n@for $i from 1 through 60 {\n  .seconds_#{$i} {\n    transition: transform $i * 1s linear;\n    img {\n      transition: all $i * 1s linear;\n    }\n  }\n}\n\n@for $i from 0 through 30 {\n  .scroll-width-#{$i} {\n    /* .left-nav {\n      .nav {\n        margin-right: -$i * 1px;\n        box-sizing: content-box;\n        overflow: scroll;\n        position: relative;\n      }\n    } */\n    // .custom-tabs-root {\n    //  margin-top: -$i * 1px;\n    // }\n    // .custom-tabs-scrollable {\n    //   position: relative;\n    //   bottom: -$i * 1px;\n    // }\n    .geofence-modal-form-inner {\n      margin-right: -$i * 1px;\n    }\n    .notification-scroller {\n      margin-right: -$i * 1px;\n    }\n  }\n}\n\n//@for $i from 1 through 30 {\n//  .scroll-width-#{$i} #scrollableDiv1,\n//  .scroll-width-#{$i} #scrollableDiv2,\n//  .scroll-width-#{$i} #scrollableDiv4,\n//  .scroll-width-#{$i} #scrollableDiv{\n//    margin-right: -$i * 1px;\n//    margin-bottom: -$i * 1px;\n//    padding-bottom: $i * 1px;\n//    //padding-right: $i * 1px;\n\n//    box-sizing: content-box;\n//  }\n//}\n\n.ref-marker {\n  background: none;\n}\n.pos-name {\n  //text-align: center;\n  position: absolute;\n  width: 320px;\n  left: 50%;\n  margin-left: -160px;\n  //white-space: nowrap;\n  bottom: 100%;\n  //letter-spacing: 1px;\n  box-sizing: border-box;\n\n  /* span {\n    font-size: 12px;\n    background: #fff;\n    border-radius: 3px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);\n    padding: 6px;\n    display: inline-block;\n  } */\n  display: none;\n}\n.marker:hover {\n  .pos-name {\n    display: block;\n  }\n}\n\n.custom-marker.leaflet-marker-icon {\n  background: none;\n  border: 0;\n  img {\n    max-width: 100% !important;\n    height: auto;\n  }\n}\n\n.hide-delete-btn .leaflet-draw-actions-bottom {\n  display: none !important;\n}\n\n.form-group {\n  margin-bottom: 25px;\n}\n\n.hilight {\n  border: 1px solid $borderColor;\n  color: $themeColor;\n  background: #fff;\n  padding: 6px;\n  display: inline-block;\n  border-radius: 4px;\n  margin: 6px 0;\n}\n\n.inline-buttons {\n  .theme-button,\n  button {\n    margin-right: 8px;\n  }\n}\n.ml-auto {\n  margin-left: auto;\n}\n\n.page-title {\n  font-size: 14px;\n  font-weight: 700;\n  padding: 0 0 4px;\n  margin: 0 0 10px;\n  font-weight: normal;\n}\n.page-title-notification {\n  margin: 0 0 10px;\n  padding: 0 0 4px;\n  font-weight: bold;\n  font-size: 14px;\n}\n.page-subtitle-notification {\n  font-weight: normal;\n  margin: 0;\n  padding: 0 0 4px;\n  font-size: 14px;\n}\n.report-list-wrapper {\n  .ScrollbarsCustom-Wrapper {\n    margin: 0 -15px;\n  }\n}\n.selector-check {\n  margin-right: 10px;\n}\n.report-sidebar-switch {\n  margin: 0 0px;\n  display: flex;\n  \n  &:after {\n    content: '';\n    display: block;\n    height: 1px;\n    background: #fff;\n    margin: 10px auto;\n  }\n  .theme-button {\n    min-width: 70px !important;\n    margin: 0 4px 0 0;\n  }\n  & ~ &:after {\n    margin-bottom: 0;\n  }\n}\n\n.clearAllNotifcations {\n  position: absolute;\n  z-index: 999;\n  background: #f7f7f7;\n  border: 0;\n  width: 100%;\n  padding: 10px 30px;\n  font-size: 16px;\n  right: 10px;\n  max-width: 300px;\n  top: $headerHeight + 15px + 90px;\n  cursor: pointer;\n  box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.2);\n}\n.notifications-tr {\n  margin-top: 143px;\n}\n\n.shown-clearall-btn .notifications-tr {\n  margin-top: 195px;\n}\n\n.notification-visible {\n  height: auto !important;\n}\n.notification-dismiss {\n  font-size: 22px !important;\n  line-height: 22px !important;\n  width: 22px !important;\n  height: 22px !important;\n  background: none !important;\n  top: 6.5px !important;\n  right: 7px !important;\n}\n.progress-green,\n.notification-success {\n  background: #43a047 !important;\n  border-color: #43a047 !important;\n  color: #fff !important;\n}\n.progress-yellow,\n.notification-warning {\n  background: #ffa000 !important;\n  border-color: #ffa000 !important;\n  color: #fff !important;\n}\n.progress-red,\n.notification-error {\n  background: #d32f2f !important;\n  border-color: #d32f2f !important;\n  color: #fff !important;\n}\n.notification-info {\n  background: #1976d2 !important;\n  border-color: #1976d2 !important;\n  color: #fff !important;\n}\n.notification-title {\n  color: #fff !important;\n}\n.notification-visible {\n  color: #fff !important;\n  padding: 8px 16px !important;\n  font-size: 14px !important;\n  letter-spacing: 0.01071em;\n  line-height: 1.43;\n  border-radius: 4px !important;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2),\n    0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12) !important;\n  &:hover {\n    .notification-dismiss {\n      display: block;\n    }\n  }\n}\n\n.notification-inner-box {\n  border-radius: 4px;\n  margin: -10px -16px -8px;\n  padding: 10px 16px 8px;\n}\n\n.tab-title {\n  margin: 0 0 10px;\n  padding: 6px 12px;\n  border-radius: 7px;\n  font-weight: 600;\n}\n\n.text-danger {\n  color: #d32f2f;\n}\n\n@media (min-width: 600px) {\n  .MuiTab-root {\n    min-width: 80px !important;\n  }\n  .MuiTabs-root {\n    min-height: 32px !important;\n    margin-bottom: -5px;\n    position: relative;\n    z-index: 1;\n  }\n} \n\n.text-center {\n  text-align: center;\n}\n.text-left {\n  text-align: left;\n}\n.text-right {\n  text-align: right;\n}\n\n.text-default {\n  color: inherit;\n}\n\n.table-fields-list {\n  .smooth-dnd-draggable-wrapper {\n    &:nth-child(Odd) {\n      background: #fafafa;\n    }\n    .selected_item {\n      background: none;\n      border: 1px solid rgba(0, 0, 0, 0.15);\n    }\n  }\n}\n\n.main-menu-list-wrapper ul {\n  padding: 0;\n  overflow: hidden;\n}\n\n.theme-input-select {\n  height: 35px !important;\n  font-size: 12px !important;\n  padding: 0 !important;\n  display: flex !important;\n  border-color: #3A3A39\n}\n\n.theme-label {\n  font-size: 12px;\n  font-weight: 600 !important;\n}\n\n.theme-label-shrink {\n  margin-top: 0;\n}\n.theme-label-focused {\n  margin-top: 0;\n}\n\n.theme-textarea {\n  font-size: 14px;\n  padding: 0;\n}\n.rv-xy-plot,\n.theme-cssOutlinedInput {\n  color: inherit;\n}\n.rv-xy-plot__axis text,\n.alt-x-label text,\n.alt-y-label text {\n  fill: currentColor;\n}\n.rv-xy-plot__axis line,\n.rv-xy-plot__grid-lines line {\n  stroke: currentColor;\n}\n\n.theme-butotn.button-text {\n  padding: 6px 16px;\n}\n\n.button-text.button-narrow {\n  padding: 6px 5px;\n}\n\n.main-content-page-inner {\n  padding: 20px 26px;\n}\n.v-checkbox {\n  display: inline-block;\n  width: 18px !important;\n  height: 18px !important;\n  text-align: center;\n  border: 1px solid;\n  border-radius: 3px;\n}\n/* .theme-notchedOutline {\n  box-shadow: 0px 2px 4px 0px rgba(20, 20, 20, 0.15),\n    0px 2px 4px 0px rgba(20, 20, 20, 0.15) inset;\n} */\n\n.hr-divider {\n  border: 0;\n  margin: 0;\n  border-top: 1px solid #{$borderColor}66;\n}\n\n.button-small {\n  min-height: 28px;\n  padding-left: 16px;\n  padding-right: 16px;\n}\n\n.tab-container-outer {\n  padding: 0 16px 1px;\n  .tab-container-outer {\n    padding: 0;\n  }\n  .custom-tabs-root {\n    margin-left: -15px;\n    margin-right: -15px;\n    margin-top: 4px;\n  } \n}\n\n.button-with-icon {\n  width: 110px;\n  min-height: 124px;\n  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2),\n    0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);\n\n  span,\n  svg {\n    font-weight: normal;\n    font-size: 14px;\n    line-height: normal;\n    text-transform: none;\n    white-space: normal;\n    display: block;\n    margin: 0 auto 10px;\n  }\n}\n\n.driver-page-content {\n  border-radius: 6px 0 0 6px;\n  height: 100%;\n  .leaflet-container {\n    min-height: inherit;\n  }\n}\n\n.show-tracks,\n.show-points {\n  display: inline-flex;\n  align-items: center;\n  padding: 0 10px 0 0;\n}\nspan.form-control-label,\n.form-control-label {\n  color: inherit;\n}\n\n.material-icons {\n  vertical-align: middle;\n  color: inherit;\n  font-family: 'Material Icons';\n}\n.row-value {\n  font-weight: bold;\n  display: inline-block;\n  // font-weight: 600;\n  font-size: inherit;\n}\n.row-label {\n  font-weight: normal;\n  display: inline-block;\n}\n.license-card-img {\n  width: 60px;\n  height: 60px;\n  text-align: center;\n  padding: 8px;\n  border-radius: 6px;\n}\n.attribute-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.attribute-list li {\n  margin-bottom: 10px;\n  border-radius: 6px;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.attribute-list .row-label {\n  margin-bottom: 5px;\n  min-width: inherit;\n}\n.attribute-list .row-value {\n  font-weight: 700;\n  font-size: 12px;\n  margin-left: auto;\n}\n.trackers-list {\n  list-style: none;\n  margin: 0 0 0 -16px;\n  padding: 0;\n  text-align: center;\n}\n.trackers-list li {\n  box-sizing: border-box;\n  border-radius: 6px;\n  width: calc(25% - 16px);\n  float: left;\n  margin-left: 16px;\n  margin-bottom: 16px;\n  padding: 0;\n}\n.trackers-list .row-label {\n  font-size: 12px;\n  font-weight: normal;\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: inherit;\n}\n.trackers-list .row-value {\n  font-size: 12px;\n}\n.row-image {\n  width: 80px;\n  height: 80px;\n}\n\n.license-card-detail p {\n  display: flex;\n  flex-wrap: wrap;\n  margin: 10px 0;\n}\n.license-card-detail .row-label {\n  margin-bottom: 5px;\n}\n.license-card-detail .row-value {\n  text-align: right;\n  margin-left: auto;\n}\n.license-card-detail {\n  font-size: 12px;\n  padding: 0 0 10px;\n  margin-bottom: 30px;\n}\n\n.MuiSkeleton-pulse {\n  animation: MuiSkeleton-keyframes-pulse 1.5s ease-in-out 0.5s infinite;\n}\n@-webkit-keyframes MuiSkeleton-keyframes-pulse {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.4;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.skeleton-wave {\n  overflow: hidden;\n  position: relative;\n}\n.skeleton-wave::after {\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  content: '';\n  z-index: 1;\n  position: absolute;\n  animation: MuiSkeleton-keyframes-wave 2.6s linear 0.5s infinite;\n  transform: translateX(-100%);\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(0, 0, 0, 0.04),\n    transparent\n  );\n}\n\n.geofence-modal {\n  /*   &.hide-delete-btn {\n    .leaflet-draw-edit-remove {\n      display: none;\n    }\n  }\n */\n  display: flex;\n  &-form {\n    position: relative;\n    width: 245px;\n    z-index: 9999;\n    font-size: 12px;\n    overflow: hidden;\n    &-inner {\n      height: 310px;\n      overflow-y: scroll;\n      display: flex;\n      flex: 1;\n      flex-direction: column;\n      right: -1px;\n      position: relative;\n      > div {\n        padding: 12px 12px 1px;\n        &:nth-child(even) {\n          background: rgba($color: #fff, $alpha: 0.15);\n        }\n      }\n    }\n    .ScrollbarsCustom-Wrapper {\n      right: 0 !important;\n    }\n    .ScrollbarsCustom-Content {\n      padding: 12px !important;\n    }\n    &-footer {\n      width: 100%;\n      text-align: right;\n      border-top: 1px solid rgba(#fff, 0.15);\n      padding: 10px;\n    }\n  }\n  .dialog-full-screen & &-form {\n    .geofence-modal-form-inner {\n      height: calc(100% - 50px);\n    }\n  }\n  &-map {\n    flex: 1;\n  }\n\n  .dialog-full-screen & {\n    height: calc(100vh - 44px);\n  }\n}\n.notification-wizard {\n  margin: 0;\n  padding: 0;\n  .theme-button {\n    border-radius: 0;\n    padding: 8px 15px;\n    font-size: 15px;\n    text-transform: none;\n    svg {\n      display: block;\n    }\n    .row-related-icon {\n      margin-left: auto;\n      transform: rotate(-90deg);\n    }\n    &.active {\n      .row-related-icon {\n        transform: rotate(0);\n      }\n    }\n  }\n  li {\n    margin-top: 6px;\n  }\n}\n.notification-wizard-inner {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  .theme-button {\n    font-size: 13px;\n    border-radius: 0;\n    padding: 8px 15px 8px 35px;\n  }\n  .custom-indicator {\n    background: #fff !important;\n  }\n}\n\n\n\n.unread {\n  cursor: pointer;\n}\n.unread .read-unread-mark {\n  width: 10px;\n  height: 10px;\n  border-radius: 10px;\n  float: right;\n}\n\n.maintain-height {\n  margin-top: 28px;\n}\n.notification-head-row {\n  padding: 5px 10px;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n}\n\n\n@keyframes MuiSkeleton-keyframes-wave {\n  0% {\n    transform: translateX(-100%);\n  }\n  60% {\n    transform: translateX(100%);\n  }\n  100% {\n    transform: translateX(100%);\n  }\n}\n.skeleton-pulse {\n  animation: MuiSkeleton-keyframes-pulse 1.5s ease-in-out 0.5s infinite;\n}\n@keyframes MuiSkeleton-keyframes-pulse {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.4;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n.alert {\n  padding: 6px 9px;\n  border: 1px solid;\n  border-radius: 4px;\n  margin: 20px auto;\n  font-size: $baseFontSize;\n  svg {\n    vertical-align: middle;\n    margin-right: 6px;\n  }\n}\n\n.graph-total-unit {\n  font-size: 1.5em;\n  font-weight: bold;\n}\n.notification-model-common-section {\n  padding-left: 12px;\n  height: 100%;\n  &.opened {\n    height: 100%;\n  }\n}\n.highcharts-data-label {\n  .pie-tooltip {\n    display: flex;\n    &-image {\n      width: 26px;\n      align-items: center;\n      justify-content: center;\n      display: flex;\n      border-radius: 4px;\n      padding: 5px;\n    }\n    &-label {\n      padding-left: 10px;\n      font-family: $baseFontFamily;\n      align-items: center;\n      display: flex;\n      b {\n        font-size: 1.8em;\n        font-weight: 900;\n        padding-right: 7px;\n      }\n    }\n  }\n  .pie-tooltip-half-1 {\n    .pie-tooltip-image {\n      order: 1;\n    }\n    .pie-tooltip-label {\n      order: 0;\n      padding-left: 0;\n      padding-right: 10px;\n      text-align: right;\n    }\n  }\n}\n.highcharts-text-outline {\n  display: none;\n}\n.scroll-auto {\n  overflow: auto !important;\n}\n.scroll-visible {\n  overflow: visible !important;\n}\n.motion-status-bar {\n  display: flex;\n  height: 33px;\n  align-items: center;\n  border-radius: 4px;\n  & ~ & {\n    margin-top: 5px;\n  }\n  .motion-status-img {\n    margin-right: 10px;\n  }\n  .motion-status-name {\n    min-width: 0;\n    margin-right: 10px;\n    flex: 1;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n  img {\n    width: 20px;\n    height: 20px;\n  }\n  .motion-status-border {\n    width: 10px;\n    border-radius: 4px;\n    height: 100%;\n    margin-right: 10px;\n  }\n  .motion-status-count {\n    font-weight: bold;\n    margin-left: auto;\n    padding-right: 15px;\n  }\n  &.multi-columns {\n    margin-top: 5px;\n    width: calc(50% - 2.5px);\n    .motion-status-border {\n      margin-right: 8px;\n    }\n    .motion-status-img {\n      margin-right: 8px;\n      img {\n        width: 26px;\n        height: 26px;\n      }\n    }\n  }\n}\n.motion-status-bar2 {\n  transition: all 0.2s ease;\n  &:hover {\n    background: #B2B5C4 !important;\n    color: #fff !important;\n  }\n}\n\n.multi-columns-wrap {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n\n.driver-state-wrap {\n  > h3 {\n    font-size: 2em;\n    margin-bottom: 0;\n  }\n  > p {\n    font-size: 1.3em;\n    margin: 0 0 16px;\n  }\n  .driver-state-container {\n    display: flex;\n    flex: 1;\n    flex-wrap: wrap;\n    margin-left: -12px;\n  }\n  .driver-state,\n  .driver-state2 {\n    width: calc(50% - 12px);\n    margin-left: 12px;\n    margin-bottom: 12px;\n    padding: 17px 15px 10px;\n    border-radius: 6px;\n    text-align: center;\n    color: #fff;\n    h3 {\n      font-size: 18px;\n      margin-bottom: 5px;\n      margin-top: 10px;\n    }\n    p {\n      margin-top: 5px;\n    }\n    &.online {\n      background: #28a745;\n    }\n    &.offline {\n      background: #dc3545;\n    }\n    &.not-register {\n      background: #566374;\n    }\n    &.not-update {\n      background: #1976d2;\n    }\n  }\n  /* .driver-state {\n    width: calc(50% - 24px);\n    margin-left: 16px;\n    margin-bottom: 12px;\n    padding: 10px;\n    border-radius: 6px;\n    img {\n      margin-top: 3px;\n      float: left;\n    }\n    h3 {\n      font-size: 20px;\n      margin: 0;\n      margin-left: 45px;\n    }\n    p {\n      margin-top: 0;\n      margin-bottom: 0;\n      margin-left: 45px;\n    }\n  } */\n}\n\n.button-to-normal {\n  cursor: pointer;\n  background: none;\n  border: 0;\n  color: inherit;\n  font-size: 18px;\n  padding: 0 0 0 10px;\n  vertical-align: middle;\n}\n\n.MuiDialog-paper {\n  overflow-y: visible !important;\n}\n\n.theme-range-slider {\n  height: 8px !important;\n}\n.theme-range-slider .theme-range-slider-thumb {\n  height: 24px;\n  width: 24px;\n  background-color: #fff;\n  border: 2px solid currentColor;\n  margin-top: -8px;\n  margin-left: -12px;\n}\n.theme-range-slider .theme-range-slider-label {\n  left: calc(-50% + 4px);\n  top: -22px;\n}\n\n/* .theme-range-slider .theme-range-slider-label * {\n  background: transparent;\n} */\n.theme-range-slider .theme-range-slider-rail,\n.theme-range-slider .theme-range-slider-track {\n  height: 8px;\n  border-radius: 4px;\n}\n\n.fake-calendar {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  border-top: 1px solid rgba(#000, 0.15);\n  border-left: 1px solid rgba(#000, 0.15);\n  li {\n    float: left;\n    width: 20%;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-right: 1px solid rgba(#000, 0.15);\n    border-bottom: 1px solid rgba(#000, 0.15);\n  }\n  label {\n    cursor: pointer;\n    display: inline-block;\n    width: 2em;\n    height: 2em;\n    text-align: center;\n    line-height: 2;\n    border-radius: 40px;\n  }\n  .selected-day label {\n    background: rgba(#000000, 0.25);\n  }\n  .highlight label {\n    background: rgba(#000000, 0.5);\n  }\n}\n.fake-calendar-result {\n  float: right;\n  margin-bottom: 10px;\n}\n\n.rta__autocomplete {\n  color: #333;\n  z-index: 99;\n}\n.rta__list {\n  max-height: 150px;\n  border: 0;\n  overflow: auto;\n}\n\n.rta__entity {\n  padding: 6px 12px;\n  font-size: 0.8em;\n}\n.menu_item_text{\n  color: #000;\n\n}\n.menu_item_text_inner {\n  display: flex;\n  text-align: left;\n}\n::-webkit-input-placeholder {\n  /* Chrome/Opera/Safari */\n  color: rgba(#fff, 0.5);\n}\n::-moz-placeholder {\n  /* Firefox 19+ */\n  color: rgba(#fff, 0.5);\n}\n:-ms-input-placeholder {\n  /* IE 10+ */\n  color: rgba(#fff, 0.5);\n}\n:-moz-placeholder {\n  /* Firefox 18- */\n  color: rgba(#fff, 0.5);\n}\n.react-time-picker__clear-button {\n  display: none;\n}\n\n.react-time-picker__wrapper {\n  padding: 2px 10px 3px;\n  border-radius: 4px;\n}\n.react-time-picker__inputGroup__input {\n  outline: 0;\n}\n\n.messages-table {\n  font-size: 12px;\n}\n\n\n.theme-builder-module {\n  padding: 20px;\n  h1 {\n    margin: 0 0 10px;\n  }\n  \n}\n\n.step-label-root {\n  .MuiStepLabel-iconContainer {\n    display: none;\n  }\n}\n\n.dnd-ebuilder-wrapper {\n  padding: 16px;\n  box-shadow: 0px 2px 1px -1px rgba(#000, 0.2), 0px 1px 1px 0px rgba(#000, 0.14), 0px 1px 3px 0px rgba(#000, 0.12);\n}\n.dnd-ebuilder {\n  padding: 15px;\n  border-radius: 6px;\n  h3 {\n    margin-top: 4px;\n    margin-bottom: 0;\n  }\n  h4 {\n    margin-top: 5px;\n    margin-bottom: 5px;\n  }\n\n  .dnd-drop {\n    border: 1px dashed;\n    border-radius: 6px;\n    padding: 15px;\n    border-radius: 6px;\n    min-height: 100px;\n    flex: 1;\n  }\n\n  .dnd-dropable {\n    background: rgba(0,0,0,0.15);\n  }\n\n  .tag {\n    border-radius: 4px;\n    padding: 6px 12px;\n    margin-right: 8px;\n    display: inline-block;\n    vertical-align: middle;\n  }\n\n  .dropable-placehoder {\n    border: 1px dashed;\n    padding: 4px 12px;\n    height: 2em;\n    min-width: 120px;\n    display: inline-block;\n    vertical-align: middle;\n  }\n  .dnd-placeholder {\n    margin-bottom: 0;\n    position: relative;\n    p {\n      font-weight: bold;\n      margin-top: 5px;\n      margin-bottom: 5px;\n    }\n  }\n\n  .dnd-box {\n    margin-right: 0.5rem;\n    padding: 0.25rem 0.75rem;\n    margin-bottom: 0.5rem;\n    border-radius: 3px;\n    cursor: move;\n    display: inline-block    \n  }\n\n  .text-right .dnd-box {\n    margin-right: 0;\n    margin-left: 1rem;\n  }\n\n  .dnd-empty {\n    text-align: center;\n    h2 {\n      font-size: 1em;\n      margin-top: 0;\n    }\n    svg {\n      width: 40px;\n    }\n  }\n\n  .action-rollback-btn {\n    position: absolute;\n    top: 9px;\n    right: 1px;\n  }\n\n}\n\n.feature-close-button {\n  position: absolute;\n  // margin-top: 16px;\n  // color: #747474;\n  right: 15px;\n  // top: 3px;\n  font-size: 24px !important;\n  cursor: pointer;\n  // &:hover {\n  //   color: #000;\n  // }\n}\n.driver-modal-fixed,\n.feature-row-1,\n.feature-row {\n  // width: 50%;\n  width: 23%;\n  position: fixed;\n  top: 20px + $headerHeight;\n  right: 55px;\n  background-color: #ffffff;\n  // left: $headerNavWidth + $sidebarWidth + 10px;\n  box-shadow: 0px 0px 1px rgba(12, 26, 75, 0.24), 0px 3px 8px -1px rgba(50, 50, 71, 0.05);\n  border-radius: 8px;\n  // box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);\n   z-index: 1;\n}\n\n.driver-modal-fixed {\n  left: auto;\n  z-index: 9999;\n  bottom: 20px;\n  width: $sidebarWidth;\n}\n\n.feature-row {\n  // padding: 12px;\n}\n.feature-row-head {\n  // padding: 0 0 8px;\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 1.2;\n  // background-color: #dcdcdc;\n  border-radius: 10px;\n  padding: 8px 5px 0px 5px;\n  .feature-row-head-name {\n    display: inline-block;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 165px;\n    vertical-align: top;\n  }\n}\n.feature-row-inner {\n  height: calc(100vh - #{$headerHeight} - #{$footerHeight} - 64px - 60px);\n  font-size: 12px;\n}\n\n.feature-section {\n  display: block;\n  border-radius: 10px;\n  line-height: 1.4;\n  position: relative;\n  transition: all 0.3s ease;\n  padding: 20px 7px 10px;\n  font-size: 0.8em;\n  \n  .row-label {\n    margin-right: 10px;\n    font-size: 12px;\n  }\n  &.alternate\n  .row-value {\n    display: block;\n  }\n\n  .feature-content-section {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    padding:3px 5px;\n    background-color: #F0F4F7;\n    .item-row {\n      min-width: 30%;\n    }\n  }\n  .feature-box-Icons{\n    background: #FFFFFF;\n    box-shadow: 0px 0px 1px rgba(12, 26, 75, 0.24), 0px 3px 8px 0px rgba(50, 50, 71, 0.05);\n    border-radius: 8px;\n    span {\n      display: block;\n      padding: 6px 18px 4px;\n    }\n  }\n\n  h3 {\n    font-weight: 600;\n    margin-top: 0;\n    margin-bottom: 10px;\n  }\n  /* &:hover {\n\t\t//z-index: 1;\n\t\t//transform: scale(1.02);\n\t\t.feature-section-close {\n\t\t\tdisplay: block;\n\t\t}\n\t} */\n  .list-unstyled {\n    margin: 0;\n    padding: 0;\n  }\n}\n\n\n.fms-notification-inner {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n\n}\n\n\n\n/****** Chat Popup Layout ******/\n.msg_head,\n.boxhandle-icon {\n  cursor: move;\n}\n.msg_box{\n  position: fixed;\n  bottom: 30px;\n  overflow: hidden;\n  z-index: 9999999;\n  border: 1px solid rgba($color: #000000, $alpha: 0.5);\n  background: #fff;\n}\n.msg_head{\n  align-items: center;\n  font-weight: bold;\n  font-size: 12px;\n  display: flex;\n  > div {\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n  .msg-unit-icon {\n    width: 30px;\n    height: 30px;\n  }\n}\n.closebox {\n  cursor: pointer;\n  padding: 3px;\n  &:hover {\n    background: rgba(#000, 0.15);\n  }\n  svg {\n    fill: currentColor;\n    width: 24px;\n    height: 24px;\n    display: block;\n  }\n}\n.boxhandle-icon {\n  height: 10px;\n}\n\n.react-contextmenu.react-contextmenu--visible {\n  min-width: 220px;\n  background: #fff;\n  border: solid 1px #DADCE0;\n  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.04);\n}\n.react-contextmenu {\n  .react-contextmenu-item {\n    cursor: pointer;\n    display: block;\n    padding: 5px 40px;\n    font-size: 11px;\n    font-weight: normal;\n    color: #202124;\n  }\n\n  .react-contextmenu-item--selected {\n    background: #C8C8C9;\n  }\n}\n\n\n.collapse-report-form {\n  position: absolute;\n  right: 5px;\n  top: 16px;\n}\n\n\n\n//.ScrollbarsCustom-Scroller{padding-right: 0 !important; margin: 0 !important;}\n@media (max-width: 959px) {\n  .show-tracks,\n  .show-points {\n    display: none;\n  }\n\n  .sensors-buttons {\n    .theme-button {\n      margin: 5px !important;\n    }\n  }\n}\n\n@media (max-width: 767px) {\n  .license-card-img {\n    float: none;\n    width: auto;\n  }\n  .license-card-detail {\n    margin-left: 0;\n  }\n}\n@media (max-width: 479px) {\n  .trackers-list li {\n    width: calc(100% - 16px);\n  }\n}\n\n@media (max-width: 959px) {\n  .driver-page-content {\n    border-radius: 6px;\n  }\n}\n\n.react-base-table {\n  table-layout: fixed;\n  border-collapse: collapse;\n  .MuiTableCell-sizeSmall:last-child,\n  .MuiTableCell-sizeSmall {\n    padding: 6px;\n  }\n  a,\n  .MuiTableCell-root {\n    color: inherit;\n    position: relative;\n  }\n  .MuiTableCell-head {\n    font-weight: bold;\n  }\n  .MuiTableCell-body {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n  .MuiTableCell-head {\n    white-space: normal;\n  }\n  .MuiTableCell-body a {\n    display: inline-block;\n    overflow: inherit;\n    text-overflow: inherit;\n    white-space: inherit;    \n  }\n}\n\n.react-base-table-wrapper {\n  .resizer {\n    display: block;\n    width: 10px;\n    height: 100%;\n    position: absolute;\n    right: 0;\n    top: 0;\n    z-index: 1;\n    touch-action:none;\n\n    &.isResizing {\n      background: rgba(#000000, 0.05);\n    }\n  }\n  .MuiPaginationItem-root,\n  .MuiTablePagination-root,\n  .MuiPaginationItem-root {\n    color: inherit;\n  }\n\n  .MuiTablePagination-actions .MuiIconButton-root {\n    padding: 3px;\n  }\n  .MuiTablePagination-toolbar {\n    min-height: 40px;\n  }\n  .MuiPaginationItem-root {\n    height: 27px;\n    min-width: 27px;\n  }\n}\n\n\n.btn-link {\n  font-size: 0.8em;\n  padding: 0 4px;\n  color: currentColor;\n  padding: 5px 10px;\n  background: rgba(white, 0.25);\n  margin-right: 6px;\n  border-radius: 4px;\n  &.active {\n    font-weight: bold;\n  }\n}\n\n.dashboard-page-header {\n  box-shadow: 0 4px 8px rgba(#000, 0.08);\n  display: flex;\n  align-items: center;\n  padding: 16px;\n  border-radius: 10px;\n  font-weight: 600;\n  font-size: 16px;\n  svg {\n    margin-right: 10px;\n  }\n}\n\n.device-status-box {\n  cursor: pointer;\n  // border: 1px solid;\n  // padding: 20px;\n  // margin: 0 5px 0 5px;\n  // max-width: 135px;\n  // border-radius: 12px;\n  display: flex;\n  /* &.no-outline {\n    padding: 0;\n    border: 0;\n  } */\n  .device-status-icon {\n    color: #fff;\n    width: 60px;\n    height: 48px;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center; \n    svg {\n      display: block;\n    }\n  }\n  span {\n    display: block;\n    font-size: 16px;\n    font-weight: normal;\n  }\n  em {\n    font-style: normal;\n    font-size: 12px;\n    font-weight: normal;\n  }\n}\n\n.device-status-icon {\n  &.online {\n    background: #28a745;\n  }\n  &.offline {\n    background: #dc3545;\n  }\n  &.not-register {\n    background: #566374;\n  }\n  &.not-update {\n    background: #1976d2;\n  }\n}\n\n.units-category-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  white-space: nowrap;\n  display: flex;\n  align-items: top;\n  justify-content: flex-start;\n  li {\n    cursor: pointer;\n    flex-direction: column;\n    margin: 0;\n    display: flex;\n    min-width: 80px;\n    white-space: normal;\n    text-align: center;\n  }\n  .unit-value {\n    margin-top: 10px;\n    font-weight: 600;\n    font-size: 16px;\n  }\n  .unit-label {\n    font-size: 12px;\n    line-height: 1.3;\n  }\n}\n\n.recharts-wrapper {font-size: 12px;}\n\n.MuiIconButton-root.search-close-icon,\n.search-close-icon {\n  position: absolute;\n  right: 6px;\n  top: 10px;\n}\n\n.sensor_type_head {\n  display: flex;\n}\n\n.sensor-collapse-wrapper {\n  padding: 0px 13px;\n  border-radius: 10px;\n  // & ~ & {\n  //   // margin-top: 11px;  \n  // }  \n} \n\n.sensor-row {\n  // display: flex;\n  // align-items: center;\n  // padding: 6px 13px;\n  .sensor-row-input,\n  .sensor-row-description,\n  .sensor-row-title {\n    width: 150px;\n  }\n  .sensor-row-actions {\n    margin-left: auto;\n  }\n  \n}\n\n.sensor-row:first-child {\n  // border-top: 1px solid #e1e1e1;\n  // padding-top: 13px;\n  // margin-top: 13px;\n}\n\n.notification-page-wrapper {\n  // padding: 16px;\n}","@import \"functions\";\n@import \"mixins\";\n$themeColor: #00c179;\n$input-focus-box-shadow: none;\n$input-btn-focus-box-shadow: none;\n$btn-active-box-shadow: none;\n$input-focus-border-color: inherit;\n$btn-active-box-shadow: none;\n$input-bg: #fbfeff;\n$input-border-radius: 100px;\n$input-border-radius-sm: 100px;\n$input-border-radius-lg: 100px;\n$input-border-color: #e2e9ef;\n//$input-padding-x-sm: 10px;\n@import \"bs_variables\";\n\n// Layouts\n$sidebarWidth : 320px;\n$sidebarWidthResponsive : $sidebarWidth;\n$logoSectionHeight: 50px;\n$headerNavWidth: 50px;\n$headerNavWidthExpended: 200px;\n$headerHeight: 50px;\n$footerHeight: 0;\n$mapFiltersHeight: 36px;\n$mapWidgetsHeight: 150px;\n$topGap: $headerHeight + 3px;\n\n$themeColorInverse: #fff;\n$textColor: #333;\n$body-color: #333;\n$logoColor: $themeColor; //#012D55;\n\n\n\n// Header \n\n$borderColor: #B2B5C4;\n$linkColor: #fff;\n$hoverBg: #fff;\n$hoverColor: $themeColor;\n$hoverBorderColor: transparent;\n$subMenuHoverBg: $hoverBg;\n$subMenuHoverColor: $hoverColor;\n$menuBg: #045266;\n$blue : #012D55;\n\n\n// general\n$darkGrey: #666;\n$badgeColor: #fff;\n$badgeBgColor: $darkGrey;\n$greenColor: #28a745;\n$redColor: #dc3545;\n$skyColor: $themeColor;\n$yellowColor: #ffc107;\n$bodyBg: #e0e0e0;\n$lightGrey: #d7d7d7;\n\n$dropdown-bg: #fff;\n$dropdown-border: darken($dropdown-bg, 30%);\n\n\n\n$danger : $redColor;\n$warning : $yellowColor;\n$success : $greenColor;\n\n\n// Sidebar \n$sidebarBackground: #fff;\n$sidebarzIndex: 1;\n$sidebarHeadBg: #ffffff;\n$sidebarRowBg: #fff;\n$sidebarRowHoverBg: #f7f7f7;\n$sidebarRowColor: $darkGrey;\n\n\n// typography\n$baseFontSize: 14px;\n$baseIconFontSize: 17px;\n\n\n// Footer\n\n$footerBackground: #ececec;\n$footerFontSize: $baseFontSize + 2;\n\n\n\n\n\n$baseFontFamily: Poppins, sans-serif;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
